<script>
import { defineComponent } from "vue";
import PromptBox from "../Tips/PromptBox.vue";
import Tips from "../Tips/Tips.vue";
import { initializeApp } from "firebase/app";
import {
  logout,
  RedePtion,
  requestHttp,
  requestt,
  TheServer2,
  Automaticlogon,
  TheServer3,
  checkGolegame,
  getNewestVersion,
  // 以下的都是新增
  getGameConfigNew, // 以下的都是新增
  serverList, // 以下的都是新增
  memberPayAutoLogin, // 以下的都是新增
  functionServerRoleInfo, // 以下的都是新增
  functionGetGoodsList,
  memberPayUstoreLogin,
  memberPayLogout,
  functionUserInfo,
  roleInfoBindCheck,
  functionGetPayGoodsInfo,
  functionPayChannel,
  functionPayPoints,
  payOrderApply,
} from "../../utils/axios";
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signOut,
} from "firebase/auth";
import { mapGetters } from "vuex";
import i18n from "@/lang/index";
import { mapMutations } from "vuex";
import crypto from "crypto";
import Notice from "../Tips/Tips";
let app = null;
export default defineComponent({
  setup() {
    return {};
  },
  components: {
    PromptBox,
    Tips,
  },
  data() {
    return {
      ReScription: false,
      activeVar: "",
      activeVars: "",
      Paydata: [], //内构项
      payModes: [], //支付方式
      checkindex: "",
      TipShow: false,
      gameInput: "",
      titles: "",
      contentt: "",
      titlesl: "",
      TipShowl: false,
      //服务器
      Theserver: [],
      Theserver2: [],
      selectValue: "", //服务器绑定的值
      selectValue2: "", //登录后服务器绑定的值
      sellRole: "",
      sellRole2: "",
      roleNames: "", //角色名称
      roleNames2: "", //登录后角色名称
      roleIds: "", //角色id
      roleIds2: "", //登录角色ID
      serverIds: "", //服务器id
      serverIds2: "", //登录后的服务器ID
      serverNames: "", //服务器名s
      serverNames2: "", //服务器名
      size1: "",
      paychannelRequestUrl: "",
      access_tok: "",
      access_toks: "", //成功/失败/取消
      ConfirmRecharge: false, //充值确认
      productsCodes: "", //商品id
      productsNames: "", //商品名
      payClo: false, //登录的弹框   控制登录弹框显示

      logintrue: "3",
      GameUrl: "", //获取登录时候url的gameid
      urlgameid: "",
      gameBannerIcon: "", //头图
      gameH5BannerIcons: "", //头图icon
      logintrue2: false,
      mail: "",
      password: "",
      showPassword: false,
      mark: "", //显示信息
      price: "", //显示数目
      loginTypes: {
        ulu: 2,
        facebook: 3,
        google: 4,
        twitter: 5,
        gamecenter: 6,
        apple: 8,
      },
      loginvisib: false, // 记录是否登录
      checkTip: "", //校验提示
      checkTion: false,
      gamerole: "",
      gamerole2: "",
      serverIds3: "",
      PrServer: true, //是否开始服务器列表
      checkuser: {},
      appname: "",
      bottomsAs: true,
      passwordsd: "",
      extraDataL: "",
      extraDataL2: "",

      newestPackageUrl: "", // 新增 下载地址
      qrCodeIcon: "", // 新增 下载二维码

      // 以下是新增  适配ustore
      gameReleaseType: "", //1、2联运和独代   3cps  游戏发行类型：当为3时，需要查询是否绑定角色
      roleCheckType: "", // 角色确认方式:1根据uid查角色信息;2:先查区服再进行角色校验;3:直接角色校验
      serverRoleList: [], // 服务器角色  游戏为1、2时  获取的数据
      selectServerRole: "", // 选中的服务器和角色

      serverList: [], // 未打通  服务器列表
      selectServer: "", // 未打通 选中的服务器
      queryRoleID: "", // 输入查询的角色id
      userInfoObj: "", // 用户信息
      userIcon: "",
      tabPaneArr: [], // 切换卡
      // activeName: "", // 活跃的选项卡
      tableData1: [], // 数据源
      selectedIndex: 0,
      selectedObj: {}, // 选项卡选中的对象

      roleIdCommon: "", // 选择角色后  公用角色id去查询商品

      // 打通游戏  下拉选中的   独代和联运的角色信息
      roleIdTemp: "",
      roleNameTemp: "",
      serverIdTemp: "",
      serverNameTemp: "",

      // 未打通游戏  下拉选中的  cps
      serverIdTempCps: "",
      serverNameTempCps: "",
      roleIdTempCps: "", // 输入要校验的角色id

      // 未打通游戏  校验后  cps返回的信息
      extraDataCpsReturn: "",
      serverIdCpsReturn: "",
      serverNameCpsReturn: "",
      roleIdCpsReturn: "",
      roleNameCpsReturn: "",

      // 商品详情结果
      payGoodsInfo: "", // 商品详情对象
      PayChannel: [], // 支付方式
      PayChannelSelectID: "", // 选中的支付方式id
      PayChannelSelectName: "", // 选中的支付方式name

      payGoodsDetail: false, // 商品详情支付弹框

      goodsInfoTableList: [], // 支付弹框中   商品详情列表

      couponIdArr: [], //获取优惠券数组
      couponIdArrObj: {}, // 选中优惠券的对象
      webCouponCode: "", // 选中的优惠券id

      payPoints: "", // 获取的积分

      orderApplyReturn: "", // 创建订单后   返回的结果

      giftContent: i18n.global.t("RechargePage.InTheQuery"), // 礼包内容  鼠标放上去展示

      isFirst: true,

      isPurchaseLimit: false, // 接口购买上限
    };
  },

  created() {
    document.title = i18n.global.t("customer.RechargeCores");
    this.gameInput = localStorage.getItem("gameName");
    this.GameUrl = this.parseParam(window.location.href);
    if (this.GameUrl.gameId) {
      this.urlgameid = this.GameUrl.gameId;
      localStorage.setItem("gameId", this.urlgameid);
      // this.RecgeDes();

      this.getGameConfig();
      this.getFunctionGetGoodsList();
    } else {
      if (localStorage.getItem("gameId")) {
        // this.RecgeDes();

        this.getGameConfig();
        this.getFunctionGetGoodsList();
      } else {
        Notice({ message: i18n.global.t("customer.obtainGameFail") });
      }
    }
    // 获取二维码和下载地址
    this.getVersionInfo();
  },

  mounted() {
    let tookens = localStorage.getItem("token");
    if (!tookens) {
      this.access_tok = this.parseParam(window.location.href);
      if (this.access_tok.access_token) {
        this.bindAccount(
          this.access_tok.access_token,
          this.access_tok.sub,
          "apple"
        );
      }
    }
    const firebaseConfig = {
      apiKey: "AIzaSyDyaXD4Xe-9qbuzohpBfiOD5LSW_78IC-o",
      authDomain: "web-pay-be562.firebaseapp.com",
      projectId: "web-pay-be562",
      storageBucket: "web-pay-be562.appspot.com",
      messagingSenderId: "516740762718",
      appId: "1:516740762718:web:08a479e398cbd9c746b8cf",
      measurementId: "G-XNDZ6ZL6BM",
    };
    app = initializeApp(firebaseConfig);
    this.token = localStorage.getItem("token");
    this.access_toks = this.parseParam(window.location.href);
    if (this.access_toks.code) {
      if (this.access_toks.code == "10") {
        this.TipShow = true;
        this.titles = i18n.global.t("RechargePage.OrderCompleted");
        this.contentt = i18n.global.t("RechargePage.SuccessBuy");
      } else if (this.access_toks.code == "11") {
        this.TipShow = true;
        this.titles = i18n.global.t("RechargePage.OrderHathair");
        this.contentt = i18n.global.t("RechargePage.HelpConCusSer");
        localStorage.removeItem("uuid");
      } else if (this.access_toks.code == "12") {
        Notice({ message: i18n.global.t("RechargePage.Ordercancelled") });
        localStorage.removeItem("uuid");
      }
    }
  },

  methods: {
    isValidEmail(email) {
      if (!email || email.length > 254) {
        return false;
      }

      const atIndex = email.indexOf("@");
      if (atIndex <= 0 || atIndex !== email.lastIndexOf("@")) {
        return false;
      }

      const localPart = email.slice(0, atIndex);
      const domain = email.slice(atIndex + 1);
      const localPartPattern =
        /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*$/;
      const domainLabelPattern =
        /^[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?$/;
      const domainLabels = domain.split(".");

      return (
        localPart.length <= 64 &&
        localPartPattern.test(localPart) &&
        domainLabels.length >= 2 &&
        domainLabels.every((label) => domainLabelPattern.test(label))
      );
    },
    getPreferenceStorageKey() {
      const gameId = localStorage.getItem("gameId");
      const uid = localStorage.getItem("uid");

      if (!gameId || !uid) {
        return "";
      }

      return `ustoreWebPayPreferences:${gameId}:${uid}`;
    },
    getLocalPreferences() {
      const storageKey = this.getPreferenceStorageKey();
      if (!storageKey) {
        return {};
      }

      try {
        const preferences = JSON.parse(
          localStorage.getItem(storageKey) || "{}"
        );
        return preferences &&
          typeof preferences === "object" &&
          preferences.role
          ? { role: preferences.role }
          : {};
      } catch {
        return {};
      }
    },
    cacheRolePreference(role) {
      if (
        !role ||
        role.roleId === "" ||
        role.roleId === undefined ||
        role.roleId === null
      ) {
        return;
      }

      const storageKey = this.getPreferenceStorageKey();
      if (!storageKey) {
        return;
      }

      try {
        localStorage.setItem(
          storageKey,
          JSON.stringify({
            role: {
              roleId: role.roleId,
              serverId: role.serverId ?? "",
            },
          })
        );
      } catch {
        return;
      }
    },
    getServerRoleValue(role) {
      return JSON.stringify([
        String(role.serverId ?? ""),
        String(role.roleId ?? ""),
      ]);
    },
    restoreConnectedRolePreference() {
      const cachedRole = this.getLocalPreferences().role;
      if (!cachedRole || !Array.isArray(this.serverRoleList)) {
        return;
      }

      const selectedRole = this.serverRoleList.find(
        (role) =>
          String(role.roleId) === String(cachedRole.roleId) &&
          String(role.serverId ?? "") === String(cachedRole.serverId ?? "")
      );
      if (!selectedRole) {
        return;
      }

      const selectedRoleValue = this.getServerRoleValue(selectedRole);
      this.selectServerRole = selectedRoleValue;
      this.changeServerRoleList(selectedRoleValue);
    },
    restoreCpsRolePreference() {
      const cachedRole = this.getLocalPreferences().role;
      if (
        !cachedRole ||
        cachedRole.roleId === "" ||
        cachedRole.roleId === undefined ||
        cachedRole.roleId === null
      ) {
        return;
      }

      const roleCheckType = String(this.roleCheckType);
      if (roleCheckType === "2") {
        const selectedServer = this.serverList.find(
          (server) =>
            String(server.serverId) === String(cachedRole.serverId ?? "")
        );
        if (!selectedServer) {
          return;
        }

        this.selectServer = selectedServer;
        this.serverIdTempCps = selectedServer.serverId;
        this.serverNameTempCps = selectedServer.serverName;
      } else if (roleCheckType !== "3") {
        return;
      }

      this.roleIdTempCps = String(cachedRole.roleId);
      this.queryRoleSubmit();
    },
    // 新增  state
    // 立即支付
    paySubmit() {
      // 判断登录
      if (!this.loginvisib) {
        Notice({ message: i18n.global.t("RechargePage.PleLoginFirst") });
        return;
      }
      if (!localStorage.getItem("token")) {
        Notice({ message: i18n.global.t("RechargePage.PleLoginFirst") });
        return;
      }

      if (this.PayChannelSelectID === "" || undefined) {
        Notice({ message: i18n.global.t("customer.placePayMode") });
        return;
      }

      var serverIdTemp = "";
      var serverNameTemp = "";
      var roleIdTemp = "";
      var roleNameTemp = "";
      // 打通
      if (this.roleCheckType === 1) {
        serverIdTemp = this.serverIdTemp;
        serverNameTemp = this.serverNameTemp;
        roleIdTemp = this.roleIdTemp;
        roleNameTemp = this.roleNameTemp;
      }
      // 未打通
      if (this.roleCheckType === 2 || this.roleCheckType === 3) {
        serverIdTemp = this.serverIdCpsReturn;
        serverNameTemp = this.serverNameCpsReturn;
        roleIdTemp = this.roleIdCpsReturn;
        roleNameTemp = this.roleNameCpsReturn;
      }

      let gameId = localStorage.getItem("gameId");
      let params = {
        gameId: gameId, //游戏id
        goodsId: this.payGoodsInfo.goodsId,
        quantity: 1,
        serverId: serverIdTemp,
        serverName: serverNameTemp,
        roleId: roleIdTemp,
        roleName: roleNameTemp,
        extraData: this.extraDataCpsReturn, //透传字段
        uluExtraData: "", //透传参数，可为空
        payChannelId: this.PayChannelSelectID, //支付渠道Id
        payChannelExtraData: this.PayChannelSelectName, // 支付渠道透传字段
        couponCode: this.webCouponCode, // 优惠券code
        platform: 5, // 默认5
      };

      let jsonStrings = JSON.stringify(params);
      const sm2 = require("sm-crypto").sm2;
      const cipherMode = 1; //1-c1c3c2,0 - c1c2c3,默认为1
      const publicKeys =
        "041d6651ec6a3d687d68a4b976ae43250509004f9fe29e2dd5ba7fe249d8ea8fc7669cbbf3fbb28c31811f073c0ac4545e84163bc435a0916bef7568c61f14a671";
      let encryptStr = sm2.doEncrypt(jsonStrings, publicKeys, cipherMode);
      let encryptStrH = "04" + encryptStr;
      payOrderApply({
        encryptStr: encryptStrH,
      }).then((res = {}) => {
        if (res.code == 0) {
          const sm2 = require("sm-crypto").sm2;
          let siprivateKey =
            "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
          let vals = res.data; //后端返回的加密字段
          let needval = vals.substring(2); //vals后端传过来的数据
          const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
          let decryptDatas = sm2.doDecrypt(needval, siprivateKey, cipherModes); // 解密结果
          let objectdatas = JSON.parse(decryptDatas);

          this.orderApplyReturn = objectdatas;

          // window.location.href = objectdatas.channelRedirectUrl;

          window.open(objectdatas.channelRedirectUrl, "_blank");

          this.closePayTag();
        } else if (res.code == 40022) {
          Notice({
            message: i18n.global.t("RechargePage.ThePurchaseLimitOtherItems"),
          });

          this.isPurchaseLimit = true;
          this.getFunctionGetGoodsList();
        }
      });
    },

    // 关闭支付弹框时  清理字段
    closePayTag() {
      this.payGoodsDetail = false;
      this.payGoodsInfo = "";
      this.PayChannel = [];
      this.checkindex = "";
      this.PayChannelSelectID = "";
      this.PayChannelSelectName = "";

      this.goodsInfoTableList = [];
      this.couponIdArr = [];

      this.couponIdArrObj = {};
      this.webCouponCode = "";
      this.payPoints = "";
    },
    // 预计获取的积分
    getFunctionPayPoints() {
      let gameId = localStorage.getItem("gameId");
      var amount = this.totalAmount;
      var dataParm = {
        gameId: gameId,
        payAmount: amount,
      };
      let jsonString = JSON.stringify(dataParm);
      const sm2 = require("sm-crypto").sm2;
      const cipherMode = 1; //1-c1c3c2,0 - c1c2c3,默认为1
      const publicKeys =
        "041d6651ec6a3d687d68a4b976ae43250509004f9fe29e2dd5ba7fe249d8ea8fc7669cbbf3fbb28c31811f073c0ac4545e84163bc435a0916bef7568c61f14a671";
      let encryptStr = sm2.doEncrypt(jsonString, publicKeys, cipherMode);
      let encryptStrH = "04" + encryptStr;
      functionPayPoints({
        encryptStr: encryptStrH,
      }).then((res) => {
        if (res.code == 0) {
          const sm2 = require("sm-crypto").sm2;
          let siprivateKey =
            "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
          let vals = res.data; //后端返回的加密字段
          let needval = vals.substring(2); //vals后端传过来的数据
          const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
          let decryptData = sm2.doDecrypt(needval, siprivateKey, cipherModes); // 解密结果
          let objectdata = JSON.parse(decryptData);
          this.payPoints = objectdata.points;
        }
      });
    },

    // 切换优惠券
    couponObjChange() {
      this.couponIdArr.forEach((element) => {
        if (element.webCouponCode == this.webCouponCode) {
          this.couponIdArrObj = element;
        }
      });
      this.getFunctionPayPoints();
    },

    // 立即购买
    purchaseSubmit(item) {
      // 判断登录
      if (!this.loginvisib) {
        Notice({ message: i18n.global.t("RechargePage.PleLoginFirst") });
        return;
      }
      if (!localStorage.getItem("token")) {
        Notice({ message: i18n.global.t("RechargePage.PleLoginFirst") });
        return;
      }

      // 判断限购  1不限购，2每日限购，3每周限购，4每月限购，5终身限购
      if (item.purchaseLimitType != "1") {
        if (item.payLimitNum >= item.purchaseLimitNum) {
          Notice({
            message: i18n.global.t("RechargePage.ThePurchaseLimitOtherItems"),
          });
          return;
        }
      }

      // 打通  1
      if (this.roleCheckType === 1) {
        if (!this.roleIdTemp) {
          Notice({ message: i18n.global.t("RechargePage.PlsselectRole") });
          return;
        }
      }
      // 未打通  2  cps
      if (this.roleCheckType === 2) {
        if (!this.serverIdTempCps) {
          Notice({ message: i18n.global.t("RechargePage.placeChTheSer") });
          return;
        }
        if (!this.roleIdTempCps) {
          Notice({ message: i18n.global.t("RechargePage.PlaceNickID") });
          return;
        }

        // cps   判断是否被校验
        if (!this.roleIdCpsReturn) {
          Notice({ message: i18n.global.t("RechargePage.PlaceCheckID") });
          return;
        }
      }
      // 未打通  3   cps
      if (this.roleCheckType === 3) {
        if (!this.roleIdTempCps) {
          Notice({ message: i18n.global.t("RechargePage.PlaceNickID") });
          return;
        }

        // cps   判断是否被校验
        if (!this.roleIdCpsReturn) {
          Notice({ message: i18n.global.t("RechargePage.PlaceCheckID") });
          return;
        }
      }

      //  请求商品详情接口  请求支付方式
      this.getPayGoodsInfo(item);
      this.getPayChannel();

      // 唤起商品支付弹框
      this.payGoodsDetail = true;
    },

    // 鼠标放到商品上  请求商品详情
    getGoodsDetail(item) {
      var goodsId = item.goodsId;
      var dataParm = {
        goodsId: goodsId,
        roleId: this.roleIdCommon ?? "",
      };
      let jsonString = JSON.stringify(dataParm);
      const sm2 = require("sm-crypto").sm2;
      const cipherMode = 1; //1-c1c3c2,0 - c1c2c3,默认为1
      const publicKeys =
        "041d6651ec6a3d687d68a4b976ae43250509004f9fe29e2dd5ba7fe249d8ea8fc7669cbbf3fbb28c31811f073c0ac4545e84163bc435a0916bef7568c61f14a671";
      let encryptStr = sm2.doEncrypt(jsonString, publicKeys, cipherMode);
      let encryptStrH = "04" + encryptStr;
      functionGetPayGoodsInfo({
        encryptStr: encryptStrH,
      }).then((res) => {
        if (res.code == 0) {
          const sm2 = require("sm-crypto").sm2;
          let siprivateKey =
            "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
          let vals = res.data; //后端返回的加密字段
          let needval = vals.substring(2); //vals后端传过来的数据
          const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
          let decryptData = sm2.doDecrypt(needval, siprivateKey, cipherModes); // 解密结果
          let objectdata = JSON.parse(decryptData);

          var giftContentArr = [];
          // 获取优惠券数组  对优惠券数据处理
          if (objectdata.payGoodsGiftList) {
            objectdata.payGoodsGiftList.forEach((element) => {
              var item = element.giftGoodsName + "*" + element.giftGoodsNum;
              giftContentArr.push(item);
            });
          }
          var giftContentStr = giftContentArr.join(",");
          this.giftContent = giftContentStr;
        }
      });
    },
    handleMouseEnter(item) {
      // 鼠标进入时的逻辑处理
      if (item.goodsTypeDictId === 2) {
        this.giftContent = i18n.global.t("RechargePage.InTheQuery");
        this.getGoodsDetail(item);
      }
    },

    // 获取商品详情
    getPayGoodsInfo(item) {
      var goodsId = item.goodsId;
      var dataParm = {
        goodsId: goodsId,
        roleId: this.roleIdCommon ?? "",
      };
      let jsonString = JSON.stringify(dataParm);
      const sm2 = require("sm-crypto").sm2;
      const cipherMode = 1; //1-c1c3c2,0 - c1c2c3,默认为1
      const publicKeys =
        "041d6651ec6a3d687d68a4b976ae43250509004f9fe29e2dd5ba7fe249d8ea8fc7669cbbf3fbb28c31811f073c0ac4545e84163bc435a0916bef7568c61f14a671";
      let encryptStr = sm2.doEncrypt(jsonString, publicKeys, cipherMode);
      let encryptStrH = "04" + encryptStr;
      functionGetPayGoodsInfo({
        encryptStr: encryptStrH,
      }).then((res) => {
        if (res.code == 0) {
          const sm2 = require("sm-crypto").sm2;
          let siprivateKey =
            "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
          let vals = res.data; //后端返回的加密字段
          let needval = vals.substring(2); //vals后端传过来的数据
          const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
          let decryptData = sm2.doDecrypt(needval, siprivateKey, cipherModes); // 解密结果
          let objectdata = JSON.parse(decryptData);

          // 获取商品对象
          this.payGoodsInfo = objectdata;

          var payGoodsInfoArr = [];
          payGoodsInfoArr.push(objectdata);
          // 获取商品数组
          this.goodsInfoTableList = payGoodsInfoArr;

          var couponArrTemp = [];
          // 获取优惠券数组  对优惠券数据处理
          if (objectdata.userCouponInfo) {
            objectdata.userCouponInfo.forEach((element) => {

              if (
                Number(objectdata.discountAmount) >=
                Number(element.conditionAmount)
              ) {
                couponArrTemp.push(element);
              }
            });
          }
          this.couponIdArr = couponArrTemp;
          // 获取积分
          this.getFunctionPayPoints();
        }
      });
    },

    // 获取支付方式
    getPayChannel() {
      let gameId = localStorage.getItem("gameId");
      functionPayChannel(gameId).then((res) => {
        if (res.code == 0) {
          if (res.data == null) {
            Notice({ message: i18n.global.t("RechargePage.Noorvicnleund") });
          }
          const sm2 = require("sm-crypto").sm2;
          let siprivateKey =
            "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
          let vals = res.data; //后端返回的加密字段
          let needval = vals.substring(2); //vals后端传过来的数据
          const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
          let decryptData = sm2.doDecrypt(needval, siprivateKey, cipherModes); // 解密结果
          let objectdata = JSON.parse(decryptData);
          this.PayChannel = objectdata;
        }
      });
    },

    // 切换选项卡
    selectItem(obj, index) {
      this.selectedIndex = index;
      this.selectedObj = obj;
      this.tableData1 = [];

      this.Paydata.forEach((item) => {
        if (item.goodsTypeId == obj.value) {
          this.tableData1 = item.payGoodsVoList;
        }
      });
      this.isFirst = false;
    },

    // 获取游戏配置
    async getGameConfig() {
      let gameId = localStorage.getItem("gameId");
      const res = await getGameConfigNew(gameId);
      if (res.code == 0) {
        const sm2 = require("sm-crypto").sm2;
        let siprivateKey =
          "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
        let vals = res.data; //后端返回的加密字段
        let needval = vals.substring(2); //vals后端传过来的数据
        const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
        let decryptData2 = sm2.doDecrypt(needval, siprivateKey, cipherModes); // 解密结果
        let objectdata3 = JSON.parse(decryptData2);

        this.appname = objectdata3.appName;
        this.gameReleaseType = objectdata3.gameReleaseType;
        this.roleCheckType = objectdata3.roleCheckType;

        this.gameBannerIcon = objectdata3.PcGameBanner;
        this.gameH5BannerIcons = objectdata3.gameIcon;
        this.size1 = objectdata3.payExplainContent; //充值说明

        // 自动登录  然后获取角色和服务器
        if (localStorage.getItem("token") && localStorage.getItem("gameId")) {
          let tok = localStorage.getItem("token");
          if (tok && tok != "") {
            memberPayAutoLogin()
              .then((res) => {

                if (res.code == 0) {
                  let siprivateKey =
                    "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
                  let vals = res.data; //后端返回的加密字段
                  let needval = vals.substring(2); //vals后端传过来的数据
                  const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
                  let decryptData = sm2.doDecrypt(
                    needval,
                    siprivateKey,
                    cipherModes
                  ); // 解密结果
                  let objectdata = JSON.parse(decryptData);

                  if (objectdata && objectdata.token && objectdata.uid) {
                    localStorage.setItem("token", objectdata.token);
                    this.setToken(objectdata.token);
                    localStorage.setItem("uid", objectdata.uid);
                    if (localStorage.getItem("token")) {
                      this.payClo = false; //登录的弹框
                      this.loginvisib = true; // 记录是否登录
                      // 如果游戏模式  已打通   登录后  获取角色和服务器
                      if (
                        objectdata3.gameReleaseType == 1 ||
                        objectdata3.gameReleaseType == 2
                      ) {
                        this.functionServerRoleInfo();
                      }

                      // 游戏类型  没打通  要获取服务器列表
                      if (objectdata3.gameReleaseType == 3) {
                        this.getServerList();
                      }

                      // 获取用户的信息
                      this.getUserInfo();

                      if (
                        sessionStorage.getItem("googleLoginSuccess") === "1"
                      ) {
                        sessionStorage.removeItem("googleLoginSuccess");
                        Notice({
                          message: i18n.global.t("customer.loginSuccess"),
                        });
                      }
                    }
                  }
                } else {
                  sessionStorage.removeItem("googleLoginSuccess");
                }
              })
              .catch(() => {
                sessionStorage.removeItem("googleLoginSuccess");
              });
          }
        }
        // 自动登录end
      }
    },

    // 获取用户信息
    async getUserInfo() {
      // 获取
      functionUserInfo().then((res) => {
        if (res.code == 0) {
          const sm2 = require("sm-crypto").sm2;
          let siprivateKey =
            "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
          let vals = res.data; //后端返回的加密字段
          let needval = vals.substring(2); //vals后端传过来的数据
          const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
          let decryptData = sm2.doDecrypt(needval, siprivateKey, cipherModes); // 解密结果
          let objectdata = JSON.parse(decryptData);
          this.userInfoObj = objectdata;
        }
      });
    },
    // 登录后  打通 获取角色和服务器
    async functionServerRoleInfo() {
      let gameId = localStorage.getItem("gameId");
      // 获取区服角色
      functionServerRoleInfo(gameId).then((res) => {
        if (res.code == 0) {
          if (res.data == null) {
            Notice({ message: i18n.global.t("RechargePage.Noorvicnleund") });
          }
          const sm2 = require("sm-crypto").sm2;
          let siprivateKey =
            "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
          let vals = res.data; //后端返回的加密字段
          let needval = vals.substring(2); //vals后端传过来的数据
          const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
          let decryptData = sm2.doDecrypt(needval, siprivateKey, cipherModes); // 解密结果
          let objectdata = JSON.parse(decryptData);

          this.serverRoleList = objectdata;
          this.restoreConnectedRolePreference();
        }
      });
    },
    // 登录后  未打通  获取服务器列表
    getServerList() {
      let gameId = localStorage.getItem("gameId");
      // 获取区服
      serverList(gameId).then((res) => {
        if (res.code == 0) {
          if (res.data == null) {
            Notice({ message: i18n.global.t("RechargePage.Noorvicnleund") });
          }
          const sm2 = require("sm-crypto").sm2;
          let siprivateKey =
            "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
          let vals = res.data; //后端返回的加密字段
          let needval = vals.substring(2); //vals后端传过来的数据
          const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
          let decryptData = sm2.doDecrypt(needval, siprivateKey, cipherModes); // 解密结果
          let objectdata = JSON.parse(decryptData);

          this.serverList = objectdata;
          this.restoreCpsRolePreference();
        }
      });
    },
    // 获取商品列表
    getFunctionGetGoodsList() {
      let gameId = localStorage.getItem("gameId");
      var dataParm = {
        gameId: gameId,
        roleId: this.roleIdCommon ?? "",
      };
      let jsonString = JSON.stringify(dataParm);
      const sm2 = require("sm-crypto").sm2;
      const cipherMode = 1; //1-c1c3c2,0 - c1c2c3,默认为1
      const publicKeys =
        "041d6651ec6a3d687d68a4b976ae43250509004f9fe29e2dd5ba7fe249d8ea8fc7669cbbf3fbb28c31811f073c0ac4545e84163bc435a0916bef7568c61f14a671";
      let encryptStr = sm2.doEncrypt(jsonString, publicKeys, cipherMode);
      let encryptStrH = "04" + encryptStr;
      functionGetGoodsList({
        encryptStr: encryptStrH,
      }).then((res) => {
        if (res.code == 0) {
          if (res.data == null) {
            // Notice({ message: i18n.global.t("RechargePage.Noorvicnleund") });
          }
          const sm2 = require("sm-crypto").sm2;
          let siprivateKey =
            "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
          let vals = res.data; //后端返回的加密字段
          let needval = vals.substring(2); //vals后端传过来的数据
          const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
          let decryptData = sm2.doDecrypt(needval, siprivateKey, cipherModes); // 解密结果
          let objectdata = JSON.parse(decryptData);

          this.Paydata = objectdata; //总数据源

          // 选项卡数据源
          var tabPaneArrTemp = [];
          objectdata.forEach((item) => {
            item.goodsTypeConfigId = item.goodsTypeId;
            tabPaneArrTemp.push({
              value: item.goodsTypeId,
              label: item.goodsTypeName,
            });
          });
          this.tabPaneArr = tabPaneArrTemp;

          if (this.isFirst) {
            // 如果是第一次 初始化赋值
            this.selectedIndex = 0;
            this.selectedObj = this.tabPaneArr[0];
            // table数据源
            this.tableData1 = objectdata[0].payGoodsVoList;
          } else {
            this.Paydata.forEach((item) => {
              if (item.goodsTypeId == this.selectedObj.value) {
                this.tableData1 = item.payGoodsVoList;
              }
            });
          }
          // 上限
          if (this.isPurchaseLimit) {
            // 如果是第一次 初始化赋值
            this.selectedIndex = 0;
            this.selectedObj = this.tabPaneArr[0];
            // table数据源
            this.tableData1 = objectdata[0].payGoodsVoList;

            this.isPurchaseLimit = false;
          }
        }
      });
    },
    // 调用登录接口
    async loginNew() {
      const email = this.mail.trim();
      if (email === "") {
        Notice({ message: i18n.global.t("customer.PlaceEmail") });
        return;
      }
      if (!this.isValidEmail(email)) {
        Notice({ message: i18n.global.t("customer.EmailFormatError") });
        return;
      }
      this.mail = email;
      if (this.password === "") {
        Notice({ message: i18n.global.t("customer.PlacePassword") });
        return;
      }

      //ulu帐号登录
      if (this.password) {
        var md5 = crypto.createHash("md5");
        md5.update(this.password);
        this.passwordsd = md5.digest("hex").toUpperCase();
      }

      let languagels = localStorage.getItem("lang");
      const datas = {
        loginType: 2,
        accessId: "",
        accessToken: "",
        mail: this.mail,
        password: this.passwordsd,
        channelId: 11,
        platform: 5,
        language: languagels,
        extraMap: {},
      };

      let jsonString = JSON.stringify(datas);
      const sm2 = require("sm-crypto").sm2;
      const cipherMode = 1; //1-c1c3c2,0 - c1c2c3,默认为1
      const publicKeys =
        "041d6651ec6a3d687d68a4b976ae43250509004f9fe29e2dd5ba7fe249d8ea8fc7669cbbf3fbb28c31811f073c0ac4545e84163bc435a0916bef7568c61f14a671";
      let encryptStr = sm2.doEncrypt(jsonString, publicKeys, cipherMode);
      let encryptStrH = "04" + encryptStr;
      memberPayUstoreLogin({
        encryptStr: encryptStrH,
      }).then((res) => {
        if (res.code == 0) {
          let siprivateKey =
            "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
          let vals = res.data; //后端返回的加密字段
          let needval = vals.substring(2); //vals后端传过来的数据
          const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
          let decryptData = sm2.doDecrypt(needval, siprivateKey, cipherModes); // 解密结果

          let objectdata = JSON.parse(decryptData);

          if (!objectdata || !objectdata.token || !objectdata.uid) {
            Notice({ message: i18n.global.t("RechargePage.Invaildlogin") });
            return;
          }
          localStorage.setItem("token", objectdata.token);
          localStorage.setItem("uid", objectdata.uid);
          this.setToken(objectdata.token);

          this.payClo = false;
          this.loginvisib = true;
          if (this.gameReleaseType == 1 || this.gameReleaseType == 2) {
            this.functionServerRoleInfo();
          }
          if (this.gameReleaseType == 3) {
            this.getServerList();
          }
          // 获取用户的信息
          this.getUserInfo();
          Notice({ message: i18n.global.t("customer.loginSuccess") });
        }
      });
    },
    // 点击登出按钮
    async changsroNew() {
      const res = await memberPayLogout({});
      if (res.code != 0) {
        return;
      }

      localStorage.removeItem("token");
      localStorage.removeItem("uid");
      sessionStorage.removeItem("googleLoginSuccess");
      if (app) {
        await signOut(getAuth(app)).catch(() => undefined);
      }
      window.location.reload();
    },
    // 切换服务器角色下拉框时 打通的游戏  联运和独代   响应的方法
    changeServerRoleList(selectedRoleValue) {
      const selectedRole = this.serverRoleList.find(
        (role) => this.getServerRoleValue(role) === selectedRoleValue
      );
      if (!selectedRole) {
        return;
      }

      this.extraDataCpsReturn = selectedRole.extraData;
      this.roleIdTemp = selectedRole.roleId;
      this.roleNameTemp = selectedRole.roleName;
      this.serverIdTemp = selectedRole.serverId;
      this.serverNameTemp = selectedRole.serverName;
      this.roleIdCommon = selectedRole.roleId;

      this.cacheRolePreference(selectedRole);
      this.getFunctionGetGoodsList();
    },
    //  未打通的游戏   切换服务器时  选中的区服信息
    changeServerList() {
      this.serverIdTempCps = this.selectServer.serverId;
      this.serverNameTempCps = this.selectServer.serverName;

      this.roleIdTempCps = "";

      this.roleNameCpsReturn = "";
      this.roleIdCpsReturn = "";
      this.serverIdCpsReturn = "";
      this.serverNameCpsReturn = "";
    },
    // 未打通的游戏  点击校验  输入框的角色id
    queryRoleSubmit() {
      let gameId = localStorage.getItem("gameId");

      if (this.roleIdTempCps == "") {
        Notice({ message: i18n.global.t("RechargePage.PlaceNickID") });
        return;
      }
      if (this.roleCheckType == "2") {
        if (!this.serverIdTempCps) {
          Notice({ message: i18n.global.t("RechargePage.placeChTheSer") });
          return;
        }
        this.checkuser = {
          gameId: gameId,
          roleId: this.roleIdTempCps,
          serverId: this.serverIdTempCps,
          serverName: this.serverNameTempCps,
        };
      } else if (this.roleCheckType == "3") {
        this.checkuser = {
          gameId: gameId,
          roleId: this.roleIdTempCps,
        };
      }
      let jsonString = JSON.stringify(this.checkuser);
      const sm2 = require("sm-crypto").sm2;
      const cipherMode = 1; //1-c1c3c2,0 - c1c2c3,默认为1
      const publicKeys =
        "041d6651ec6a3d687d68a4b976ae43250509004f9fe29e2dd5ba7fe249d8ea8fc7669cbbf3fbb28c31811f073c0ac4545e84163bc435a0916bef7568c61f14a671";
      let encryptStr = sm2.doEncrypt(jsonString, publicKeys, cipherMode);
      let encryptStrH = "04" + encryptStr;
      roleInfoBindCheck({
        encryptStr: encryptStrH,
      }).then((res) => {
        if (res.code == 0) {
          let siprivateKey =
            "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
          let vals = res.data; //后端返回的加密字段

          let needval = vals.substring(2); //vals后端传过来的数据
          const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
          let decryptData6 = sm2.doDecrypt(needval, siprivateKey, cipherModes); // 解密结果
          let objectdata6 = JSON.parse(decryptData6);

          this.extraDataCpsReturn = objectdata6.extraData;

          this.checkTion = true;

          if (objectdata6.serverName && objectdata6.serverName != "") {
            this.checkTip =
              this.$t("RechargePage.CheckSuccess") +
              objectdata6.roleName +
              "，" +
              this.$t("RechargePage.TheServer") +
              ":" +
              objectdata6.serverName;
          } else {
            this.checkTip =
              this.$t("RechargePage.CheckSuccess") + objectdata6.roleName;
          }

          this.roleNameCpsReturn = objectdata6.roleName;
          this.roleIdCpsReturn = objectdata6.roleId;
          this.serverIdCpsReturn = objectdata6.serverId;
          this.serverNameCpsReturn = objectdata6.serverName;

          this.roleIdCommon = objectdata6.roleId; // 共用
          this.cacheRolePreference({
            roleId: objectdata6.roleId,
            serverId: objectdata6.serverId ?? this.serverIdTempCps,
          });
        } else if (res.code == 500) {
          this.checkTion = true;
          this.checkTip = this.$t("RechargePage.SystemError");
          this.roleNameCpsReturn = "";
          this.roleIdCpsReturn = "";
          this.serverIdCpsReturn = "";
          this.serverNameCpsReturn = "";

          this.roleIdCommon = ""; // 共用
        } else if (res.code == 30100) {
          this.checkTion = true;
          this.checkTip = this.$t("RechargePage.InterfaceException");
          this.roleNameCpsReturn = "";
          this.roleIdCpsReturn = "";
          this.serverIdCpsReturn = "";
          this.serverNameCpsReturn = "";

          this.roleIdCommon = ""; // 共用
        } else if (res.code == 30300) {
          this.checkTion = true;
          this.checkTip = this.$t("RechargePage.InterfaceException");
          this.roleNameCpsReturn = "";
          this.roleIdCpsReturn = "";
          this.serverIdCpsReturn = "";
          this.serverNameCpsReturn = "";

          this.roleIdCommon = ""; // 共用
        } else if (res.code == 30400) {
          this.checkTion = true;
          this.checkTip = this.$t("RechargePage.InterfaceException");
          this.roleNameCpsReturn = "";
          this.roleIdCpsReturn = "";
          this.serverIdCpsReturn = "";
          this.serverNameCpsReturn = "";

          this.roleIdCommon = ""; // 共用
        } else if (res.code == 40300) {
          this.checkTion = true;
          this.checkTip = this.$t("RechargePage.FrequentVisits");
          this.roleNameCpsReturn = "";
          this.roleIdCpsReturn = "";
          this.serverIdCpsReturn = "";
          this.serverNameCpsReturn = "";

          this.roleIdCommon = ""; // 共用
        } else if (res.code == 40517) {
          this.checkTion = true;
          this.checkTip = this.$t("RechargePage.NetworkAnomaly");
          this.roleNameCpsReturn = "";
          this.roleIdCpsReturn = "";
          this.serverIdCpsReturn = "";
          this.serverNameCpsReturn = "";

          this.roleIdCommon = ""; // 共用
        } else if (res.code == 40606) {
          this.checkTion = true;
          this.checkTip = this.$t("RechargePage.VerificationFailed");
          this.roleNameCpsReturn = "";
          this.roleIdCpsReturn = "";
          this.serverIdCpsReturn = "";
          this.serverNameCpsReturn = "";

          this.roleIdCommon = ""; // 共用
        } else {
          this.checkTion = true;
          this.checkTip = this.$t("RechargePage.NetworkAnomaly");
          this.roleNameCpsReturn = "";
          this.roleIdCpsReturn = "";
          this.serverIdCpsReturn = "";
          this.serverNameCpsReturn = "";

          this.roleIdCommon = ""; // 共用
        }

        this.getFunctionGetGoodsList();
      });
    },
    // 点击导航登录按钮
    loginBtnSubmit() {
      this.payClo = true;
    },

    // 新增  end

    ...mapMutations(["setToken"]),
    //苹果登陆后拿到拆分地址栏的函数
    parseParam(url = window.location.href) {
      // 只要 ? 后面的数据
      const [, params] = url.split("?");
      const result = {};
      params?.split("&").map((item) => {
        let [key, value = ""] = item.split("=");
        value = typeof value === Boolean ? value : decodeURIComponent(value); // 转译中文
        if (!result[key]) {
          result[key] = value;
        } else {
          // 重复出现的 key 要组装成数组
          result[key] = [].concat(result[key], value);
        }
      });
      return result;
    },

    // 获取版本最新信息
    getVersionInfo() {
      getNewestVersion().then((res) => {
        if (res) {
          if (res.code == 0) {
            this.newestPackageUrl = res.data.newestPackageUrl;
            this.qrCodeIcon = res.data.qrCodeIcon;
          }
        }
      });
    },

    //成功/失败的弹框
    closeed() {
      this.TipShow = false;
      // this.TipShow=true
    },
    //充值说明
    Recharge() {
      this.ReScription = true;
    },
    // 登录后获取屈服角色信息
    async TheSerid2() {
      // this.setToken(localStorage.getItem('token'))
      let gameId = localStorage.getItem("gameId");

      // 获取区服角色
      TheServer2(gameId).then((res) => {
        if (res.code == 0) {
          if (res.data == null) {
            Notice({ message: i18n.global.t("RechargePage.Noorvicnleund") });
          }
          const sm2 = require("sm-crypto").sm2;
          let siprivateKey =
            "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
          let vals = res.data; //后端返回的加密字段
          let needval = vals.substring(2); //vals后端传过来的数据
          const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
          let decryptData = sm2.doDecrypt(needval, siprivateKey, cipherModes); // 解密结果

          let objectdata = JSON.parse(decryptData);
          this.Theserver2 = objectdata;
        }
      });
    },
    selectvak3() {
      // this.setToken(localStorage.getItem('token'))
      let gameId = localStorage.getItem("gameId");

      // 获取区服角色
      TheServer3(gameId).then((res) => {
        if (res.code == 0) {
          if (res.data == null) {
            Notice({ message: i18n.global.t("RechargePage.Noorvicnleund") });
          }
          const sm2 = require("sm-crypto").sm2;
          let siprivateKey =
            "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
          let vals = res.data; //后端返回的加密字段
          let needval = vals.substring(2); //vals后端传过来的数据
          const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
          let decryptData = sm2.doDecrypt(needval, siprivateKey, cipherModes); // 解密结果
          let objectdata = JSON.parse(decryptData);
          this.Theserver = objectdata;
        }
      });
    },
    //获取区服角色信息
    selectvak() {
      this.serverIds = this.selectValue.serverId;
      this.serverNames = this.selectValue.serverName;
      this.roleIds = this.selectValue.roleId;
      this.roleNames = this.selectValue.roleName;

      this.sellRole = this.selectValue.roleName;
      this.extraDataL = this.selectValue.extraData;
    },
    selectvak2() {
      this.serverIds2 = this.selectValue2.serverId;
      this.serverNames2 = this.selectValue2.serverName;
      this.roleIds2 = this.selectValue2.roleId;
      this.roleNames2 = this.selectValue2.roleName;
      this.sellRole2 = this.selectValue2.roleName;
      this.extraDataL2 = this.selectValue2.extraData;
    },
    //角色昵称选择
    selseRole() {
      // this.roleIds = this.sellRole.roleId
      // this.roleNames = this.sellRole.roleName
    },
    //支付方式
    Checkfirstt(index, id) {
      this.checkindex = index;

      this.PayChannelSelectID = id;
      this.PayChannelSelectName = index;

      // for (const key in this.payModes) {

      //   if (this.payModes[key].payChannelId == id) {
      //     this.paychannelRequestUrl = this.payModes[key].channelRequestUrl;
      //   }
      // }
    },
    RechargeL(item, index) {
      this.activeVars = index;
      this.productsCodes = item.productCode;
      this.mark = item.mark;
      this.price = item.price;
    },
    //  获取充值说明
    async RecgeDes() {
      let gameId = localStorage.getItem("gameId");
      const res = await RedePtion(gameId);
      if (res.code == 0) {
        const sm2 = require("sm-crypto").sm2;
        let siprivateKey =
          "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
        let vals = res.data; //后端返回的加密字段
        let needval = vals.substring(2); //vals后端传过来的数据
        const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
        let decryptData2 = sm2.doDecrypt(needval, siprivateKey, cipherModes); // 解密结果
        let objectdata3 = JSON.parse(decryptData2);
        this.appname = objectdata3.appName;
        //   else{
        //
        this.logintrue = objectdata3.loginEnable; //是否开始登录
        if (objectdata3.loginEnable == 1) {
          this.bottomsAs = false;
        }
        if (objectdata3.serverEnable == 0) {
          this.PrServer = false;
        } else {
          this.PrServer = true;
        }

        // }
        // 自动登录
        if (localStorage.getItem("token") && localStorage.getItem("gameId")) {
          let tok = localStorage.getItem("token");
          if (tok && tok != "") {
            Automaticlogon().then((res) => {
              if (res.code == 0) {
                if (res.data && res.data.token && res.data.uid) {
                  localStorage.setItem("token", res.data.token);
                  this.setToken(res.data.token);
                  localStorage.setItem("uid", res.data.uid);
                  if (localStorage.getItem("token") && this.logintrue == 1) {
                    this.logintrue = "3";
                    this.bottomsAs = true;
                    this.logintrue2 = true;
                    this.TheSerid2();
                    this.payClo = false;
                    this.loginvisib = true;
                  }
                }
              }
            });
          }
        }
        this.Paydata = objectdata3.payProductList;
        this.gameBannerIcon = objectdata3.gameBannerIcon;
        this.gameH5BannerIcons = objectdata3.gameIcon;
        this.size1 = objectdata3.payGameExplainConfigVo.content;
        this.mark = objectdata3.payProductList[0].mark;
        this.price = objectdata3.payProductList[0].price;
        this.productsCodes = objectdata3.payProductList[0].productCode;
        this.payModes = objectdata3.paymentChannelVoList;
        if (this.logintrue == 0 && this.PrServer == true) {
          this.selectvak3();
        }
      }
    },
    // 点击登录按钮
    payClo2() {
      this.payClo = true;
    },

    veriTion() {
      let gameId = localStorage.getItem("gameId");

      if (this.gamerole == "") {
        Notice({ message: i18n.global.t("RechargePage.PlaceNickID") });
        return;
      }
      if (this.PrServer == true) {
        if (this.serverNames == "") {
          Notice({ message: i18n.global.t("RechargePage.placeChTheSer") });
          return;
        }
        this.checkuser = {
          gameId: gameId,
          roleId: this.gamerole,
          serverId: this.serverIds,
        };
      } else {
        this.checkuser = {
          gameId: gameId,
          roleId: this.gamerole,
        };
      }
      let jsonString = JSON.stringify(this.checkuser);
      const sm2 = require("sm-crypto").sm2;
      const cipherMode = 1; //1-c1c3c2,0 - c1c2c3,默认为1
      const publicKeys =
        "041d6651ec6a3d687d68a4b976ae43250509004f9fe29e2dd5ba7fe249d8ea8fc7669cbbf3fbb28c31811f073c0ac4545e84163bc435a0916bef7568c61f14a671";
      let encryptStr = sm2.doEncrypt(jsonString, publicKeys, cipherMode);

      let encryptStrH = "04" + encryptStr;
      checkGolegame({
        encryptStr: encryptStrH,
      }).then((res) => {
        if (res.code == 0) {
          let siprivateKey =
            "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
          let vals = res.data; //后端返回的加密字段

          let needval = vals.substring(2); //vals后端传过来的数据
          const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
          let decryptData6 = sm2.doDecrypt(needval, siprivateKey, cipherModes); // 解密结果
          let objectdata6 = JSON.parse(decryptData6);
          this.extraDataL = objectdata6.extraData;

          this.checkTion = true;
          localStorage.setItem("uuidd", objectdata6.uid);
          this.checkTip =
            this.$t("RechargePage.CheckSuccess") + objectdata6.roleName;
          this.roleNames = objectdata6.roleName;
          this.gamerole2 = objectdata6.roleId;
          this.serverIds3 = objectdata6.serverId;
          this.serverNames = objectdata6.serverName;
        } else if (res.code == 500) {
          this.checkTion = true;
          this.checkTip = this.$t("RechargePage.SystemError");
          this.gamerole2 = "";
          this.serverNames = "";
        } else if (res.code == 30100) {
          this.checkTion = true;
          // this.checkTip=i18n.global.t("customer.InterfaceException")
          this.checkTip = this.$t("RechargePage.InterfaceException");
          this.gamerole2 = "";
          this.serverNames = "";
        } else if (res.code == 30300) {
          this.checkTion = true;
          this.checkTip = this.$t("RechargePage.InterfaceException");
          this.gamerole2 = "";
          this.serverNames = "";
        } else if (res.code == 30400) {
          this.checkTion = true;
          this.checkTip = this.$t("RechargePage.InterfaceException");
          this.gamerole2 = "";
          this.serverNames = "";
        } else if (res.code == 40300) {
          this.checkTion = true;
          this.checkTip = this.$t("RechargePage.FrequentVisits");
          this.gamerole2 = "";
          this.serverNames = "";
        } else if (res.code == 40517) {
          this.checkTion = true;
          this.checkTip = this.$t("RechargePage.NetworkAnomaly");
          this.gamerole2 = "";
          this.serverNames = "";
        } else if (res.code == 40606) {
          this.checkTion = true;
          this.checkTip = this.$t("RechargePage.VerificationFailed");
          this.gamerole2 = "";
          this.serverNames = "";
        } else {
          this.checkTion = true;
          this.checkTip = this.$t("RechargePage.NetworkAnomaly");
          this.gamerole2 = "";
          this.serverNames = "";
        }
      });
    },
    // 点击登录 调用登录接口
    async login() {
      const email = this.mail.trim();
      if (email === "") {
        Notice({ message: i18n.global.t("customer.PlaceEmail") });
        return;
      }
      if (!this.isValidEmail(email)) {
        Notice({ message: i18n.global.t("customer.EmailFormatError") });
        return;
      }
      this.mail = email;
      if (this.passWord == "") {
        Notice({ message: i18n.global.t("customer.PlacePassword") });
        return;
      }

      //ulu帐号登录
      if (this.password) {
        var md5 = crypto.createHash("md5");
        md5.update(this.password);
        this.passwordsd = md5.digest("hex").toUpperCase();
      }
      let gameIds = localStorage.getItem("gameId");

      const datas = {
        gameId: gameIds,
        loginType: 2,
        accessId: "",
        accessToken: "",
        mail: this.mail,
        password: this.passwordsd,
        channelId: 11,
        platform: 5,
        language: languagels,
        extraMap: {},
      };

      if (datas.gameId == null) {
        Notice({ message: i18n.global.t("customer.obtainGameFail") });
        return;
      }
      let jsonString = JSON.stringify(datas);
      const sm2 = require("sm-crypto").sm2;
      const cipherMode = 1; //1-c1c3c2,0 - c1c2c3,默认为1
      const publicKeys =
        "041d6651ec6a3d687d68a4b976ae43250509004f9fe29e2dd5ba7fe249d8ea8fc7669cbbf3fbb28c31811f073c0ac4545e84163bc435a0916bef7568c61f14a671";
      let encryptStr = sm2.doEncrypt(jsonString, publicKeys, cipherMode);
      let encryptStrH = "04" + encryptStr;
      let languagels = localStorage.getItem("lang");
      requestt({
        encryptStr: encryptStrH,
      }).then((res) => {
        if (res.code == 0) {

          let siprivateKey =
            "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
          let vals = res.data; //后端返回的加密字段
          let needval = vals.substring(2); //vals后端传过来的数据
          const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
          let decryptData = sm2.doDecrypt(needval, siprivateKey, cipherModes); // 解密结果
          let objectdata = JSON.parse(decryptData);
          localStorage.setItem("token", objectdata.token);
          localStorage.setItem("uid", objectdata.uid);
          this.setToken(res.data.token);
          objectdata.gameList.forEach((item) => {
            localStorage.setItem("gameName", item.gameName);
            localStorage.setItem("gameId", item.gameId);
          });
          this.payClo = false;
          this.bottomsAs = true;
          if (localStorage.getItem("token") && this.logintrue == 1) {
            this.TheSerid2();
            this.logintrue = "3";
            this.logintrue2 = true;
            this.payClo = false;
            this.loginvisib = true;
          }
          if (this.logintrue == 0) {
            this.payClo = false;
            this.loginvisib = true;
          }
        }
      });
    },

    //谷歌
    loginGoogle(name) {
      const provider = new GoogleAuthProvider();
      provider.setCustomParameters({ prompt: "select_account" });
      // provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
      const auth = getAuth(app);
      //auth().currentUser.getIdToken
      signInWithPopup(auth, provider)
        .then((result) => {
          // This gives you a Google Access Token. You can use it to access the Google API.
          const credential = GoogleAuthProvider.credentialFromResult(result);
          // The signed-in user info.
          const user = result.user;
          this.bindAccount(credential.idToken, user.providerData[0].uid, name);
          // ...
        })
        .catch((error) => {
          // // Handle Errors here.
          // const errorCode = error.code;
          // const errorMessage = error.message;
          // // The email of the user's account used.
          // const email = error.customData.email;
          // The AuthCredential type that was used.
          GoogleAuthProvider.credentialFromError(error);
          // ...
        });
    },

    //第三方登录
    async changeLogin(name) {
      //谷歌
      if (name == "google") {
        let gameIds = localStorage.getItem("gameId");
        if (gameIds == null) {
          Notice({ message: i18n.global.t("customer.obtainGameFail") });
          return;
        }
        this.loginGoogle(name);
      }
      //facebook
      if (name == "facebook") {
        let gameIds = localStorage.getItem("gameId");
        if (gameIds == null) {
          Notice({ message: i18n.global.t("customer.obtainGameFail") });
          return;
        }
        window.FB.login((res) => {
          if (res.authResponse) {
            this.bindAccount(
              res.authResponse.accessToken,
              res.authResponse.userID,
              name
            );
            localStorage.setItem("loginWay", name);
          }
        });
      }
      //苹果
      if (name == "apple") {
        let gameIds = localStorage.getItem("gameId");
        if (gameIds == null) {
          Notice({ message: i18n.global.t("customer.obtainGameFail") });
          return;
        }
        window.AppleID.auth.init({
          clientId: "com.ulugame.webpay",
          redirectURI:
            "https://sdk.ulugame.com/v2/api/member/apple/webpay/getCode",
          usePopup: false,
          scope: "email",
          state: gameIds,
        });
        try {
          const task = window.AppleID.auth.signIn();
          localStorage.setItem("isapple", "1");
          task.catch(() => undefined);
        } catch {
          return;
        }
      }
    },
    //第三方接口
    bindAccount(accessToken = "", accessId = "", name) {
      let gameIds = localStorage.getItem("gameId");
      const languagels = localStorage.getItem("lang");
      const data = {
        loginType: this.loginTypes[name],
        accessId,
        accessToken,
        gameId: gameIds,
        channelId: 11,
        platform: 5,
        language: languagels,
        extraMap: {},
      };

      let jsonString = JSON.stringify(data);
      const sm2 = require("sm-crypto").sm2;
      const cipherMode = 1; //1-c1c3c2,0 - c1c2c3,默认为1
      const publicKeys =
        "041d6651ec6a3d687d68a4b976ae43250509004f9fe29e2dd5ba7fe249d8ea8fc7669cbbf3fbb28c31811f073c0ac4545e84163bc435a0916bef7568c61f14a671";
      let encryptStr = sm2.doEncrypt(jsonString, publicKeys, cipherMode);
      let encryptStrH = "04" + encryptStr;

      //this.showChoose=true

      requestt({ encryptStr: encryptStrH }).then((res) => {
        if (res.code == 0) {
          let siprivateKey =
            "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
          let vals = res.data; //后端返回的加密字段
          let needval = vals.substring(2); //vals后端传过来的数据
          const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
          let decryptData = sm2.doDecrypt(needval, siprivateKey, cipherModes); // 解密结果
          let objectdata = JSON.parse(decryptData);
          if (!objectdata || !objectdata.token || !objectdata.uid) {
            return;
          }
          localStorage.setItem("token", objectdata.token);
          localStorage.setItem("uid", objectdata.uid);
          this.setToken(objectdata.token);
          if (Array.isArray(objectdata.gameList)) {
            objectdata.gameList.forEach((item) => {
              localStorage.setItem("gameName", item.gameName);
              localStorage.setItem("gameId", item.gameId);
            });
          }
          if (name === "google") {
            sessionStorage.setItem("googleLoginSuccess", "1");
            window.location.reload();
            return;
          }
          this.bottomsAs = true;
          this.payClo = false;
          if (localStorage.getItem("token") && this.logintrue == 1) {
            this.TheSerid2();
            this.logintrue = "3";
            this.logintrue2 = true;
            this.payClo = false;
            this.loginvisib = true;
          }
          if (this.logintrue == 0) {
            this.payClo = false;
            this.loginvisib = true;
          }
        }
      });
    },
    //  支付
    RechargeGoodsLY() {
      if (localStorage.getItem("token") && this.logintrue == "3") {
        let gameId = localStorage.getItem("gameId");
        let uid = localStorage.getItem("uid");
        let params = {
          gameId: gameId, //游戏id
          uid: uid, // 用户id
          pgcode: this.checkindex, //支付方式，玩家选择。市场确认
          productCode: this.productsCodes, //商品id
          roleId: this.roleIds2, //角色id
          roleName: this.roleNames2, //角色名
          serverId: this.serverIds2, //服务器id
          serverName: this.serverNames2, //服务器名
          extraData: this.extraDataL2, //CP透传参数，输入角色id时，返回，可为空
          uluExtraData: "", //透传参数，可为空
          sdkVersion: "v2", //版本号，可为空
        };

        if (this.checkindex == "" || undefined) {
          Notice({ message: i18n.global.t("customer.placePayMode") });
          return;
        }
        if (this.roleIds2 == "" || undefined) {
          Notice({ message: i18n.global.t("RechargePage.Noorvicnleund") });
          return;
        }
        if (this.serverIds2 == "" || undefined) {
          Notice({ message: i18n.global.t("RechargePage.placeChTheSer") });
          return;
        }
        let jsonStrings = JSON.stringify(params);
        const sm2 = require("sm-crypto").sm2;
        const cipherMode = 1; //1-c1c3c2,0 - c1c2c3,默认为1
        const publicKeys =
          "041d6651ec6a3d687d68a4b976ae43250509004f9fe29e2dd5ba7fe249d8ea8fc7669cbbf3fbb28c31811f073c0ac4545e84163bc435a0916bef7568c61f14a671";
        let encryptStr = sm2.doEncrypt(jsonStrings, publicKeys, cipherMode);
        let encryptStrH = "04" + encryptStr;
        requestHttp({
          url: this.paychannelRequestUrl,
          data: { encryptStr: encryptStrH },
        }).then((res = {}) => {
          if (res.code == 0) {
            const sm2 = require("sm-crypto").sm2;
            let siprivateKey =
              "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
            let vals = res.data; //后端返回的加密字段
            let needval = vals.substring(2); //vals后端传过来的数据
            const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
            let decryptDatas = sm2.doDecrypt(
              needval,
              siprivateKey,
              cipherModes
            ); // 解密结果
            let objectdatas = JSON.parse(JSON.stringify(decryptDatas));
            window.location.href = objectdatas;
          }
        });
      } else {
        if (localStorage.getItem("gameId")) {
          let gamesid = localStorage.getItem("gameId");
          let uuidd = localStorage.getItem("uuidd");

          let params = {
            gameId: gamesid, //游戏id
            uid: uuidd, // 用户id
            pgcode: this.checkindex, //支付方式，玩家选择。市场确认
            productCode: this.productsCodes, //商品id
            roleId: this.gamerole2, //角色id
            roleName: this.roleNames, //角色名
            serverId: this.serverIds3, //服务器id
            serverName: this.serverNames, //服务器名
            extraData: this.extraDataL, //CP透传参数，输入角色id时，返回，可为空
            uluExtraData: "", //透传参数，可为空
            sdkVersion: "v1", //版本号，可为空
          };
          if (this.PrServer == true) {
            if (this.serverIds3 == "" || undefined) {
              Notice({
                message: i18n.global.t("RechargePage.PleaseVerifyServer"),
              });
              return;
            }
          }
          if (this.checkindex == "" || undefined) {
            Notice({ message: i18n.global.t("customer.placePayMode") });
            return;
          }
          if (this.gamerole2 == "" || undefined) {
            Notice({ message: i18n.global.t("RechargePage.PlaceCheckID") });
            return;
          }

          let jsonStrings = JSON.stringify(params);
          const sm2 = require("sm-crypto").sm2;
          const cipherMode = 1; //1-c1c3c2,0 - c1c2c3,默认为1
          const publicKeys =
            "041d6651ec6a3d687d68a4b976ae43250509004f9fe29e2dd5ba7fe249d8ea8fc7669cbbf3fbb28c31811f073c0ac4545e84163bc435a0916bef7568c61f14a671";
          let encryptStr = sm2.doEncrypt(jsonStrings, publicKeys, cipherMode);
          let encryptStrH = "04" + encryptStr;
          requestHttp({
            url: this.paychannelRequestUrl,
            data: { encryptStr: encryptStrH },
          }).then((res = {}) => {
            if (res.code == 0) {
              const sm2 = require("sm-crypto").sm2;
              let siprivateKey =
                "3d1c232074d28b315de358408a9002503eac62587f65b3f499d5933a5ca47681";
              let vals = res.data; //后端返回的加密字段
              let needval = vals.substring(2); //vals后端传过来的数据
              const cipherModes = 1; //1-c1c3c2,0 - c1c2c3,默认为1
              let decryptDatas = sm2.doDecrypt(
                needval,
                siprivateKey,
                cipherModes
              ); // 解密结果
              let objectdatas = JSON.parse(JSON.stringify(decryptDatas));
              window.location.href = objectdatas;
            }
          });
        }
      }
    },
    closeRe() {
      this.ReScription = false;
    },
    //关闭充值确认按钮
    RetionClose() {
      this.ConfirmRecharge = false;
    },
    activeFun(item, index) {
      // item 为被选中的元素体
      this.activeVar = index;
    },
    closeRo() {
      this.changsrole = false;
    },
    // 点击登出按钮
    changsro() {

      logout({}).then((res) => {
        if (res.code == 0) {
          localStorage.removeItem("token");
          window.location.href = `https://pay.ulugame.com/home/`;
        }
      });
    },
    //点击切换到密码框
    focusNext(nextRef) {
      this.$refs[nextRef].focus();
    },

    // 转换时间戳
    parseTime(time, cFormat) {
      if (arguments.length === 0 || !time) {
        return null;
      }
      const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
      let date;
      if (typeof time == "object") {
        date = time;
      } else {
        if (("" + time).length === 10) time = parseInt(time) * 1000;
        date = new Date(time);
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
      };
      const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        if (key === "a")
          return ["一", "二", "三", "四", "五", "六", "日"][value - 1];
        if (result.length > 0 && value < 10) {
          value = "0" + value;
        }
        return value || 0;
      });
      return timeStr;
    },
  },

  watch: {},
  computed: {
    ...mapGetters(["token"]),

    totalAmount() {
      var couponAmount = this.couponIdArrObj.deductibleAmount ?? 0;
      var goodAmount = "";
      if (this.payGoodsInfo.discountRate === 1) {
        goodAmount = this.payGoodsInfo.goodsAmount;
      } else {
        goodAmount = this.payGoodsInfo.discountAmount;
      }
      var toAmount = Number(goodAmount) - Number(couponAmount);
      return toAmount;
    },
  },
});
</script>

<template>
  <div class="hone">
    <!-- 弹框的黑底 -->
    <!-- <div v-show="ReScription" @click="closeRe" class="greyCover">
      <div class="Rechargeframe">
        <img @click="closeRe" src="../../assets/pay/Close.png" alt="" />
        <p>{{ $t("customer.Rechargeption2") }}</p>
        <div>
          <div>
            <div class="size1" v-html="size1"></div>
          </div>
        </div>
        <div>
          <button @click="closeRe">{{ $t("RechargePage.good") }}</button>
        </div>
      </div>
    </div> -->

    <!-- 弹框的黑底 -->
    <PromptBox
      @closeed="closeed"
      :changsrole="TipShow"
      :title="titles"
      :contents="contentt"
    >
    </PromptBox>

    <Tips @close="TipShowl = false" :visible="TipShowl" :title="titlesl">
    </Tips>

    <!-- ustore下载二维码 -->
    <div class="ustoredownload">
      <div class="ustorebg">
        <img class="imagebg" src="../../assets/pay/USTOREBG.png" alt="" />
        <img
          class="imagecode"
          src="../../assets/pay/downloads.png"
          alt="UStore download QR code"
        />
      </div>
      <a class="ustoreLine" :href="this.newestPackageUrl">
        <img src="../../assets/pay/ustbtn.png" alt="" />
      </a>
    </div>

    <!-- 新增 导航栏 -->
    <div class="nav_headers">
      <div class="nav_headers_content">
        <div class="nav_left_icon">
          <img src="../../assets/pay/U.LULogo_top_new.png" alt="" />
          <p>{{ $t("customer.RechargeCore") }}</p>
        </div>

        <div class="nav_right">
          <!-- 个人头像 -->
          <div class="right_user_icon" v-show="loginvisib">
            <img
              style="width: 100%; height: auto"
              :src="userInfoObj.userIcon"
              alt="Avatar"
            />
          </div>

          <!-- 个人信息 -->
          <div class="right_user_name" v-show="loginvisib">
            {{ userInfoObj.nickName }}
          </div>

          <!-- 退出 -->
          <div class="right_logout_bt" v-show="loginvisib">
            <p @click="changsroNew">{{ $t("RechargePage.logout") }}</p>
          </div>
          <!-- 登录 -->
          <div class="right_login_bt" v-show="!loginvisib">
            <p @click="loginBtnSubmit">{{ $t("customer.loginbtn") }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 头部内容 -->
    <div
      class="headers"
      :style="{ 'background-image': 'url(' + this.gameBannerIcon + ')' }"
    >
      <div></div>
      <div></div>
      <img :src="this.gameH5BannerIcons" alt="" />
    </div>

    <!-- content内容 -->
    <div class="contents3">
      <!-- 游戏名称 -->
      <div class="paytitle">
        <p>{{ this.appname }}</p>
      </div>
      <!-- 充值角色view -->
      <div class="paycontent">
        <div>
          <i><img src="../../assets/pay/Rectangle.png" alt="" /></i
          >{{ $t("RechargePage.PayRole") }}
        </div>

        <!-- 登录后 sdk打通  下拉选择  服务器和角色 -->
        <div
          class="paycontentCh1"
          v-show="
            loginvisib &&
            (this.gameReleaseType === 1 || this.gameReleaseType === 2)
          "
        >
          <div>
            <el-select
              v-model="selectServerRole"
              class="role-select"
              popper-class="role-select-dropdown"
              :disabled="serverRoleList.length === 0"
              :placeholder="
                serverRoleList.length > 0
                  ? $t('RechargePage.placeChTheRole')
                  : $t('RechargePage.NoorvicnleundPleaseCreate')
              "
              filterable
              @change="changeServerRoleList"
            >
              <el-option
                v-for="(item, index) in serverRoleList"
                :key="`${item.serverId}-${item.roleId}-${index}`"
                :label="`${item.roleName} · ${item.serverName}`"
                :value="getServerRoleValue(item)"
              />
            </el-select>
          </div>
        </div>

        <!--  登录后 sdk未打通   动态显示服务器下拉列表   固定显示角色查询输入框 -->
        <div
          class="paycontentCh3"
          v-show="loginvisib && this.gameReleaseType == 3"
        >
          <!--  显示服务器下拉框 -->
          <div v-if="this.roleCheckType === 2" class="serveenter">
            <select @change="changeServerList" v-model="selectServer">
              <option value="" disabled selected hidden>
                {{ $t("RechargePage.placeChTheSer") }}
              </option>
              <option
                v-for="(item, index) in serverList"
                :key="index"
                :value="item"
                :label="item.serverName"
              >
                {{ item.serverName }}
              </option>
            </select>
          </div>
          <!-- 固定显示角色id输入框 -->
          <div class="serveenter2">
            <div>
              <div>
                <input
                  type="text"
                  v-model="roleIdTempCps"
                  :placeholder="$t('RechargePage.PlaceNickID')"
                />
              </div>
              <button @click="queryRoleSubmit" type="submit">
                {{ $t("RechargePage.check") }}
              </button>
            </div>
          </div>
        </div>

        <p class="paycontentCh4" v-if="checkTion">{{ this.checkTip }}</p>

        <!-- 未登录 -->
        <div v-show="!loginvisib" class="paycontentCh2">
          <div>
            <!-- 请先登录游戏账号 -->
            <p>{{ $t("RechargePage.PleLoginFirst") }}</p>
          </div>
          <!-- 登录按钮 -->
          <div @click="this.payClo = true">
            {{ $t("customer.loginbtn") }}
          </div>
        </div>

        <!-- 登录弹框 -->
        <div v-show="payClo" class="login-modal">
          <div class="BGgrey"></div>
          <div
            class="BGgrey2 login-card"
            role="dialog"
            aria-modal="true"
            :aria-label="$t('customer.loginbtn')"
          >
            <button
              class="login-close"
              type="button"
              aria-label="Close"
              @click="this.payClo = false"
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M6 6l12 12M18 6L6 18" />
              </svg>
            </button>

            <img
              class="login-brand-logo"
              src="../../assets/pay/ulugames_login.png"
              alt="U.LU GAMES"
            />

            <div class="login-form">
              <div class="login-input-wrap">
                <svg
                  class="login-input-icon"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M4 6h16v12H4z" />
                  <path d="M4 7l8 6 8-6" />
                </svg>
                <input
                  class="login-input-field"
                  type="email"
                  autocomplete="username"
                  @keydown.enter.prevent="focusNext('mobile')"
                  v-model="mail"
                  :placeholder="$t('customer.email')"
                />
              </div>

              <div class="login-input-wrap login-password-wrap">
                <svg
                  class="login-input-icon"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <rect x="5" y="10" width="14" height="10" rx="2" />
                  <path d="M8 10V7a4 4 0 018 0v3" />
                </svg>
                <input
                  id="login-password"
                  class="login-input-field"
                  :type="showPassword ? 'text' : 'password'"
                  ref="mobile"
                  autocomplete="current-password"
                  v-model="password"
                  :placeholder="$t('customer.password')"
                  @keydown.enter.prevent="loginNew"
                />
                <button
                  class="login-password-toggle"
                  type="button"
                  :aria-label="$t('customer.password')"
                  :aria-pressed="showPassword"
                  aria-controls="login-password"
                  @click="showPassword = !showPassword"
                >
                  <svg v-if="showPassword" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12z" />
                    <circle cx="12" cy="12" r="2.5" />
                  </svg>
                  <svg v-else viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M3 3l18 18" />
                    <path d="M10.6 6.2A10.6 10.6 0 0112 6c6.5 0 10 6 10 6a17.6 17.6 0 01-2.1 2.8M6.2 6.2C3.5 8 2 12 2 12s3.5 6 10 6a10.8 10.8 0 004.1-.8" />
                  </svg>
                </button>
              </div>

              <button class="login-submit" type="button" @click="loginNew">
                {{ $t("customer.loginbtn") }}
              </button>
            </div>

            <div class="login-divider">
              <span>{{ $t("customer.otherloginMode") }}</span>
            </div>

            <div class="login-social-methods">
              <button
                class="login-social-item"
                type="button"
                @click="changeLogin('google')"
              >
                <span class="login-social-icon">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      fill="#4285F4"
                      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"
                    />
                    <path
                      fill="#34A853"
                      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                    />
                    <path
                      fill="#FBBC05"
                      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                    />
                    <path
                      fill="#EA4335"
                      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                    />
                  </svg>
                </span>
                <span class="login-social-label">Google</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 支付页 商品详情弹框 -->
      <div v-show="payGoodsDetail" class="checkout-modal">
        <div class="payGoodsDetail_blackBG"></div>
        <section
          class="payGoodsDetail_info"
          role="dialog"
          aria-modal="true"
          :aria-label="$t('RechargePage.CommoditySettlement')"
        >
          <header class="checkout-header">
            <span class="checkout-title-mark"></span>
            <h2>{{ $t("RechargePage.CommoditySettlement") }}</h2>
            <button
              class="checkout-close"
              type="button"
              aria-label="Close"
              @click="closePayTag()"
            >
              <img src="../../assets/pay/X_btn.png" alt="" />
            </button>
          </header>

          <section class="checkout-section">
            <h3 class="checkout-section-title">
              {{ $t("RechargePage.RecharRoleInformation") }}
            </h3>
            <div class="checkout-info-block">
              <div class="checkout-info-row">
                <span class="checkout-info-label">
                  {{ $t("RechargePage.TopupRole") }}
                </span>
                <span
                  v-if="this.roleCheckType == 1"
                  class="checkout-info-value"
                >
                  {{ this.roleNameTemp }}
                </span>
                <span v-else class="checkout-info-value">
                  {{ this.roleNameCpsReturn }}
                </span>
              </div>
              <div
                v-if="
                  (this.roleCheckType == 1 && this.serverIdTemp) ||
                  this.roleCheckType == 2
                "
                class="checkout-info-row"
              >
                <span class="checkout-info-label">
                  {{ $t("RechargePage.Server") }}
                </span>
                <span
                  v-if="this.roleCheckType == 1"
                  class="checkout-info-value"
                >
                  {{ this.serverNameTemp }}
                </span>
                <span v-else class="checkout-info-value">
                  {{ this.serverNameCpsReturn }}
                </span>
              </div>
            </div>
          </section>

          <section class="checkout-section">
            <h3 class="checkout-section-title">
              {{ $t("RechargePage.product") }}
            </h3>
            <div class="checkout-table-shell">
              <el-table
                class="checkout-table"
                :data="goodsInfoTableList"
                :row-key="(row) => row.id"
              >
                <el-table-column
                  prop="goodsName, goodsIcon"
                  :label="$t('RechargePage.product')"
                  min-width="350"
                >
                  <template #default="scope">
                    <div class="checkout-product">
                      <img
                        class="checkout-product-icon"
                        :src="scope.row.goodsIcon"
                        :alt="scope.row.goodsName"
                      />
                      <div class="checkout-product-copy">
                        <div
                          v-if="scope.row.goodsTypeDictId == 1"
                          class="checkout-product-name"
                        >
                          {{ scope.row.goodsNum
                          }}<span v-if="Number(scope.row.goodsExtraNum) > 0"
                            >+{{ scope.row.goodsExtraNum }}</span
                          >{{ scope.row.goodsName }}
                        </div>
                        <div v-else class="checkout-product-name">
                          {{ scope.row.goodsName }}
                        </div>
                        <div
                          v-if="scope.row.goodsTypeDictId == 2"
                          class="checkout-product-gifts"
                        >
                          <span
                            v-for="(item, index) in scope.row.payGoodsGiftList"
                            :key="index"
                          >
                            {{ item.giftGoodsName }} × {{ item.giftGoodsNum
                            }}<span
                              v-if="
                                index !== scope.row.payGoodsGiftList.length - 1
                              "
                              >、</span
                            >
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="goodsAmount"
                  :label="$t('RechargePage.Price')"
                  width="150"
                >
                  <template #default="scope">
                    <div class="checkout-price">
                      <div class="checkout-price-current">
                        <span>{{ scope.row.currencyMark }}</span>
                        <span v-if="scope.row.discountRate == 1">
                          {{ scope.row.goodsAmount }}
                        </span>
                        <span v-else>{{ scope.row.discountAmount }}</span>
                      </div>
                      <div
                        v-if="scope.row.discountRate != 1"
                        class="checkout-price-original"
                      >
                        {{ scope.row.currencyMark }}{{ scope.row.goodsAmount }}
                      </div>
                      <span
                        v-if="
                          scope.row.purchaseLimitNum &&
                          scope.row.purchaseLimitType != '1'
                        "
                        class="checkout-limit"
                      >
                        {{ $t("RechargePage.Limited") }}({{
                          scope.row.payLimitNum || 0
                        }}/{{ scope.row.purchaseLimitNum }})
                      </span>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  :label="$t('RechargePage.quantity')"
                  width="80"
                  align="center"
                >
                  <template #default>
                    <span class="checkout-quantity">1</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </section>

          <section
            v-if="this.payGoodsInfo.webCouponDiscountSwitch == 1"
            class="checkout-section"
          >
            <h3 class="checkout-section-title">
              {{ $t("RechargePage.favorable") }}
            </h3>
            <el-select
              v-model="webCouponCode"
              class="checkout-coupon"
              popper-class="checkout-coupon-dropdown"
              :placeholder="$t('RechargePage.SelectCoupon')"
              :no-data-text="$t('RechargePage.NoCouponsAvailable')"
              @change="couponObjChange"
            >
              <el-option
                v-for="item in couponIdArr"
                :key="item.webCouponCode"
                :label="`-${item.amountMark} ${item.deductibleAmount}`"
                :value="item.webCouponCode"
              >
                <div class="checkout-coupon-option">
                  <div>
                    <strong>{{ item.couponName }}</strong>
                    <span>
                      {{ $t("RechargePage.full") }}{{ item.amountMark }}
                      {{ item.conditionAmount }} - {{ item.amountMark }}
                      {{ item.deductibleAmount }}
                    </span>
                  </div>
                  <small>
                    {{ parseTime(item.expireTime, "{y}-{m}-{d}") }}
                    {{ $t("RechargePage.expire") }}
                  </small>
                </div>
              </el-option>
            </el-select>
          </section>

          <section class="checkout-section">
            <h3 class="checkout-section-title">
              {{ $t("RechargePage.PaymentMethod") }}
            </h3>
            <div class="checkout-payment-grid">
              <button
                v-for="item in PayChannel"
                :key="item.payChannelId"
                class="checkout-payment-option"
                :class="{
                  'is-selected': checkindex == item.payChannelName,
                }"
                type="button"
                :aria-label="item.payChannelName"
                @click="Checkfirstt(item.payChannelName, item.payChannelId)"
              >
                <img
                  v-if="item.payChannelIcon"
                  :src="item.payChannelIcon"
                  :alt="item.payChannelName"
                />
                <span v-else class="checkout-payment-name">
                  {{ item.payChannelName }}
                </span>
                <span
                  v-if="checkindex == item.payChannelName"
                  class="checkout-payment-check"
                  aria-hidden="true"
                >
                  ✓
                </span>
              </button>
            </div>
          </section>

          <footer class="checkout-summary">
            <div class="checkout-total">
              <div class="checkout-total-line">
                <span>{{ $t("RechargePage.total") }}</span>
                <strong>
                  {{ this.payGoodsInfo.currencyMark }} {{ this.totalAmount }}
                </strong>
              </div>
              <p>
                {{ $t("RechargePage.CompleteThePayment") }}{{ this.payPoints
                }}{{ $t("RechargePage.points") }}
              </p>
            </div>
            <button class="checkout-pay-button" type="button" @click="paySubmit">
              {{ $t("RechargePage.ImmediatePaymentNew") }}
            </button>
          </footer>
        </section>
      </div>

      <!-- 选择商品列表view -->
      <div class="paycontent3">
        <div class="titile2">
          <div class="chosse">
            <i><img src="../../assets/pay/Rectangle.png" alt="" /></i
            >{{ $t("RechargePage.ChoosCommodity") }}
          </div>
        </div>

        <div class="commodity_tab">
          <span
            v-for="(item, index) in tabPaneArr"
            :key="index"
            :class="selectedIndex === index ? 'selected' : 'noselected'"
            @click="selectItem(item, index)"
            >{{ item.label }}</span
          >
        </div>

        <!-- 商品item展示 -->
        <ul class="PayMone">
          <li class="PayMoneli">
            <ul class="PayMone2">
              <li
                :class="{ activeCss: activeVars == index }"
                @click="RechargeL(item, index)"
                v-for="(item, index) in tableData1"
                :key="index"
                class="PayMoneli2"
              >
              <!-- 商品类型id，1：货币，2礼包，3道具 -->
                <el-tooltip
                  effect="dark"
                  :content="giftContent"
                  placement="top"
                  :disabled="item.goodsTypeDictId == 2 ? false : true"
                >
                  <div @mouseenter="handleMouseEnter(item)">
                    <img :src="item.goodsIcon" alt="" />
                    <p class="good_title" v-if="item.goodsTypeDictId == 1">
                      {{ item.goodsNum }}<span v-if="Number(item.goodsExtraNum)>0">+{{ item.goodsExtraNum }}</span
                      >{{ item.goodsName }}
                    </p>
                    <p class="good_title" v-else>{{ item.goodsName }}</p>

                    <!-- 价格 -->
                    <p v-if="item.discountRate == 1" class="good_Amount">
                      {{ item.currencyMark }}{{ item.goodsAmount }}
                    </p>
                    <p v-else class="good_Amount">
                      {{ item.currencyMark }}{{ item.discountAmount }}
                      <span>{{ item.currencyMark }}{{ item.goodsAmount }}</span>
                    </p>

                    <p
                      class="good_limitNum"
                      v-if="
                        (item.purchaseLimitNum ? true : false) &&
                        item.purchaseLimitType != '1'
                      "
                    >
                      <span
                        >{{ $t("RechargePage.Limited") }}({{
                          item.payLimitNum ?? 0
                        }}/{{ item.purchaseLimitNum }})</span
                      >
                    </p>
                    <p class="good_button">
                      <button @click="purchaseSubmit(item)">
                        {{ $t("RechargePage.BuyNow") }}
                      </button>
                    </p>
                  </div>
                </el-tooltip>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <!-- 充值说明 -->
      <div class="paycontent4">
        <div class="titile2">
          <div class="chosse">
            <i><img src="../../assets/pay/Rectangle.png" alt="" /></i
            >{{ $t("customer.Rechargeption2") }}
          </div>
        </div>
        <div class="size1" v-html="size1"></div>
      </div>
    </div>

    <!-- 新增 foot底部信息 -->
    <div class="footNav">
      <div>
        <div class="foot_left">
          <img src="../../assets/pay/U.LULogo_bottom_new.png" alt="" />
        </div>
        <div class="foot_right">
          <div class="foot_right_top">
            <a
              href="https://policy.ulugame.com/policykr.html"
              target="_blank"
              >{{ $t("RechargePage.UserTermsOfService") }}</a
            >
            &nbsp;|&nbsp;
            <a href="https://policy.ulugame.com/kr.html" target="_blank">{{
              $t("RechargePage.PrivacyPolicy")
            }}</a>
            &nbsp;|&nbsp;
            <a href="https://www.ulugame.com/" target="_blank">{{
              $t("RechargePage.AboutUs")
            }}</a>
          </div>
          <div class="foot_right_bottom">
            Copyright © U.LU GAMES. All Rights Reserved.
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="bottomsC"></div> -->
    <!-- <div class="bottomsB"></div> -->
  </div>
</template>
<style lang="less">
html {
  height: 100%;
  width: 100%;
}
body {
  height: 100%;
  min-height: 100%;
  width: 100%;
  color: #252a34;
  background-color: #eef2f7;
  background-image:
    radial-gradient(ellipse at 14% 34%, rgba(75, 137, 199, 0.14), transparent 36%),
    radial-gradient(ellipse at 86% 42%, rgba(242, 68, 66, 0.09), transparent 34%),
    linear-gradient(180deg, #eaf0f7 0%, #f7f8fa 48%, #edf1f6 100%);
  background-attachment: fixed;
}
// 弹框的黑底
.greyCover {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 3;
}

* {
  margin: 0;
  padding: 0;
}
.hone {
  width: 100%;
  height: 100%;
  position: relative;
}

.payGoodsDetail_blackBG {
  position: fixed;
  inset: 0;
  z-index: 1050;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: rgba(13, 19, 30, 0.64);
  backdrop-filter: blur(2px);
}

.payGoodsDetail_info {
  --checkout-red: #c31212;
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 1051;
  width: 720px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 48px);
  padding: 32px 36px 0;
  overflow-y: auto;
  color: #333b48;
  font-family: Arial, "PingFang SC", sans-serif;
  background: #ffffff;
  border: 1px solid rgba(35, 52, 78, 0.08);
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  transform: translate(-50%, -50%);

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d8dde5;
    border-radius: 999px;
  }

  .checkout-header {
    position: relative;
    display: flex;
    min-height: 32px;
    margin-bottom: 24px;
    align-items: center;
    gap: 10px;

    .checkout-title-mark {
      width: 4px;
      height: 22px;
      background: linear-gradient(180deg, #ef3e48, #c31212);
      border-radius: 999px;
      flex: 0 0 auto;
    }

    h2 {
      margin: 0;
      color: #252a34;
      font-size: 20px;
      font-weight: 700;
      line-height: 1.4;
    }
  }

  .checkout-close {
    position: absolute;
    top: -4px;
    right: -8px;
    display: flex;
    width: 36px;
    height: 36px;
    padding: 8px;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 0;
    border-radius: 50%;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
      background: #f3f5f8;
    }

    &:focus-visible {
      outline: 2px solid rgba(195, 18, 18, 0.28);
      outline-offset: 2px;
    }

    img {
      width: 18px;
      height: 18px;
      opacity: 0.64;
    }
  }

  .checkout-section {
    text-align: left;
  }

  .checkout-section + .checkout-section {
    margin-top: 22px;
  }

  .checkout-section-title {
    margin: 0 0 10px 2px;
    color: #5f6875;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.4;
  }

  .checkout-info-block {
    display: flex;
    padding: 16px 18px;
    background: #f7f9fb;
    border: 1px solid #edf0f4;
    border-radius: 10px;
    flex-direction: column;
    gap: 12px;
  }

  .checkout-info-row {
    display: flex;
    min-height: 20px;
    align-items: center;
    gap: 16px;
  }

  .checkout-info-label {
    min-width: 76px;
    color: #929aa6;
    font-size: 12px;
    flex: 0 0 auto;
  }

  .checkout-info-value {
    min-width: 0;
    overflow: hidden;
    color: #2f3540;
    font-size: 14px;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .checkout-table-shell {
    overflow: hidden;
    border: 1px solid #e8ebf0;
    border-radius: 10px;
  }

  .checkout-table {
    --el-table-border-color: #edf0f4;
    --el-table-header-bg-color: #f7f9fb;
    --el-table-row-hover-bg-color: #ffffff;
    width: 100%;
    font-size: 14px;

    .el-table__inner-wrapper::before {
      display: none;
    }

    th.el-table__cell {
      height: 42px;
      padding: 0;
      color: #7d8591;
      font-size: 12px;
      font-weight: 600;
      background: #f7f9fb;
    }

    td.el-table__cell {
      padding: 14px 0;
    }
  }

  .checkout-product {
    display: flex;
    min-width: 0;
    align-items: center;
    gap: 14px;
  }

  .checkout-product-icon {
    width: 64px;
    height: 64px;
    border: 1px solid #eef0f3;
    border-radius: 10px;
    object-fit: contain;
    flex: 0 0 auto;
  }

  .checkout-product-copy {
    min-width: 0;
  }

  .checkout-product-name {
    overflow: hidden;
    color: #303641;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.45;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .checkout-product-gifts {
    display: -webkit-box;
    margin-top: 5px;
    overflow: hidden;
    color: #7e8794;
    font-size: 12px;
    line-height: 1.5;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .checkout-price-current {
    color: #c31212;
    font-size: 17px;
    font-weight: 700;
    line-height: 1.35;
  }

  .checkout-price-original {
    margin-top: 2px;
    color: #a6adb7;
    font-size: 12px;
    text-decoration: line-through;
  }

  .checkout-limit {
    display: inline-block;
    margin-top: 7px;
    padding: 3px 6px;
    color: #7a5700;
    font-size: 11px;
    line-height: 1.3;
    background: #fff1bd;
    border-radius: 4px;
  }

  .checkout-quantity {
    color: #4e5662;
    font-size: 14px;
    font-weight: 600;
  }

  .checkout-coupon {
    width: 100%;

    .el-input__wrapper {
      min-height: 44px;
      padding: 0 14px;
      border-radius: 8px;
      box-shadow: 0 0 0 1px #e1e5ea inset;
    }

    .el-input__wrapper.is-focus {
      box-shadow: 0 0 0 1px var(--checkout-red) inset;
    }
  }

  .checkout-payment-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }

  .checkout-payment-option {
    position: relative;
    display: flex;
    min-width: 0;
    height: 64px;
    padding: 8px 34px 8px 12px;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: #ffffff;
    border: 2px solid #eceff3;
    border-radius: 12px;
    cursor: pointer;
    transition: border-color 0.2s ease, box-shadow 0.2s ease,
      background-color 0.2s ease;

    &:hover {
      border-color: rgba(195, 18, 18, 0.62);
    }

    &:focus-visible {
      outline: 2px solid rgba(195, 18, 18, 0.25);
      outline-offset: 2px;
    }

    &.is-selected {
      background: #fff7f7;
      border-color: var(--checkout-red);
      box-shadow: 0 0 0 3px rgba(195, 18, 18, 0.08);
    }

    img {
      max-width: 100%;
      max-height: 38px;
      object-fit: contain;
    }
  }

  .checkout-payment-name {
    overflow: hidden;
    color: #333b48;
    font-size: 14px;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .checkout-payment-check {
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    width: 20px;
    height: 20px;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
    background: var(--checkout-red);
    border-radius: 50%;
  }

  .checkout-summary {
    position: sticky;
    bottom: 0;
    z-index: 2;
    display: flex;
    margin: 24px -36px 0;
    padding: 18px 36px 24px;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    background: rgba(255, 255, 255, 0.97);
    border-top: 1px solid #eceff3;
    backdrop-filter: blur(8px);
  }

  .checkout-total {
    min-width: 0;
    text-align: left;
    flex: 1;

    p {
      margin: 5px 0 0;
      color: #858d99;
      font-size: 12px;
      line-height: 1.4;
    }
  }

  .checkout-total-line {
    display: flex;
    align-items: baseline;
    gap: 10px;

    span {
      color: #606977;
      font-size: 13px;
    }

    strong {
      color: var(--checkout-red);
      font-size: 22px;
      font-weight: 700;
      line-height: 1.2;
    }
  }

  .checkout-pay-button {
    min-width: 164px;
    height: 48px;
    padding: 0 24px;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    background: linear-gradient(135deg, #c31212, #d63031);
    border: 0;
    border-radius: 10px;
    box-shadow: 0 8px 18px rgba(195, 18, 18, 0.2);
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      box-shadow: 0 10px 22px rgba(195, 18, 18, 0.28);
      transform: translateY(-1px);
    }

    &:active {
      box-shadow: 0 5px 12px rgba(195, 18, 18, 0.2);
      transform: translateY(0);
    }

    &:focus-visible {
      outline: 2px solid rgba(195, 18, 18, 0.3);
      outline-offset: 2px;
    }
  }
}

.checkout-coupon-dropdown {
  .el-select-dropdown__item {
    height: 64px;
    padding: 6px 16px;
    line-height: normal;
  }
}

.checkout-coupon-option {
  display: flex;
  min-height: 52px;
  padding: 4px 0;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  div {
    display: flex;
    min-width: 0;
    flex-direction: column;
  }

  strong {
    overflow: hidden;
    color: #343a45;
    font-size: 13px;
    line-height: 1.4;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span,
  small {
    color: #929aa6;
    font-size: 11px;
    line-height: 1.4;
  }

  small {
    flex: 0 0 auto;
  }
}

@media (max-width: 760px), (max-height: 680px) {
  .payGoodsDetail_info {
    max-height: calc(100vh - 32px);
    padding: 28px 24px 0;

    .checkout-payment-grid {
      grid-template-columns: 1fr;
    }

    .checkout-summary {
      margin-right: -24px;
      margin-left: -24px;
      padding-right: 24px;
      padding-left: 24px;
    }
  }
}

// 新增 二维码
.ustoredownload {
  width: 1.9rem;
  position: fixed;
  top: 4.03rem;
  right: 1.44rem;
  .ustorebg {
    width: 1.9rem;
    height: 2.73rem;
    position: relative;
    .imagebg {
      width: 1.9rem;
      height: 2.73rem;
    }
    .imagecode {
      position: absolute;
      width: 1.5rem;
      height: 1.5rem;
      top: 0.58rem;
      left: 0.2rem;
    }
  }
  .ustoreLine {
    width: 1.9rem;
    height: 0.52rem;
    margin-top: 0.1rem; //0.1
    cursor: pointer;
    img {
      width: 1.9rem;
      height: 0.52rem;
      margin-top: 0.1rem; //0.1
    }
  }
}
img {
  display: block;
}

.role-select-dropdown {
  .el-select-dropdown__wrap {
    max-height: 280px;
  }

  .el-select-dropdown__item {
    height: 44px;
    padding: 0 16px;
    color: #333b48;
    font-size: 15px;
    line-height: 44px;
  }

  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background: #f3f6fa;
  }

  .el-select-dropdown__item.selected {
    color: #d9001b;
    font-weight: 600;
  }
}

// 登录弹框使用
.BGgrey {
  position: fixed;
  inset: 0;
  z-index: 1000;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.62);
}
// 导航栏
.nav_headers {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999; /* 确保导航栏位于最顶层 */
  width: 100%;
  height: 0.75rem;
  background-color: rgba(255, 255, 255, 0.94);
  border-bottom: 1px solid rgba(35, 52, 78, 0.08);
  box-shadow: 0 0.04rem 0.24rem rgba(28, 43, 67, 0.08);
  backdrop-filter: blur(0.12rem);

  .nav_headers_content {
    display: flex;
    width: 100%;
    z-index: 2;
    justify-content: space-between;
    .nav_left_icon {
      display: flex;
      img {
        width: 2.91rem;
        height: 0.73rem;
        margin-left: 0.08rem;
        // margin-top: 0.24rem;
      }
      p {
        font-size: 0.18rem;
        margin-left: 0.074rem;
        font-weight: 400;
        font-family: Arial;
        color: rgb(0, 0, 0);
        margin-top: 0.27rem;
      }
    }
    .nav_right {
      display: flex;
      justify-content: space-between;

      .right_user_icon {
        width: 0.36rem;
        height: 0.36rem;
        border-radius: 50%;
        overflow: hidden;
        display: inline-block;
        background: rgb(236, 236, 236);
        margin-right: 0.2rem;
        margin-top: 0.2rem;
      }
      .right_user_name {
        height: 0.2rem;
        font-size: 0.14rem;
        font-weight: 400;
        line-height: 0.2rem;
        margin-right: 0.3rem;
        margin-top: 0.3rem;
        text-align: center;
        color: rgb(78, 78, 78);
      }
      .right_logout_bt {
        width: 0.8rem;
        height: 0.36rem;
        background: rgb(246, 245, 245);
        border-radius: 0.05rem;
        font-size: 0.16rem;
        font-weight: 400;
        color: rgb(242, 0, 29);
        margin-top: 0.2rem;
        margin-right: 0.22rem;
        text-align: center;
        line-height: 0.36rem;
        cursor: pointer;
      }
      .right_login_bt {
        width: 0.8rem;
        height: 0.36rem;
        background: rgb(242, 0, 29);
        border-radius: 0.05rem;
        font-size: 0.16rem;
        font-weight: 400;
        color: #ffffff;
        margin-top: 0.2rem;
        margin-right: 0.2rem;
        text-align: center;
        line-height: 0.36rem;
        cursor: pointer;
        // background-color: rgba(217, 0, 27, 1);
      }
    }
  }
}
// 头部banner图
.headers {
  width: 100%;
  height: 3rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;

  justify-content: space-between;
  position: relative;
  top: 0.75rem;
  isolation: isolate;

  &::after {
    content: "";
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    height: 0.32rem;
    pointer-events: none;
    background: linear-gradient(
      180deg,
      rgba(238, 242, 247, 0) 0%,
      rgba(238, 242, 247, 0.34) 46%,
      rgba(238, 242, 247, 0.88) 100%
    );
  }

  & > :nth-child(3) {
    width: 1rem;
    height: 1rem;
    position: absolute;
    top: 2.66rem;
    left: 3.6rem;
    z-index: 2;
  }
}
// 弹框的黑底
.Rechargeframe {
  position: fixed;
  width: 3.2rem;
  height: 4.64rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 0.04rem;
  z-index: 4;
  background-color: #ffffff;
  & > :nth-child(1) {
    width: 0.32rem;
    height: 0.32rem;
    position: absolute;
    right: 0.04rem;
    top: 0.04rem;
  }
  & > :nth-child(2) {
    font-size: 0.18rem;
    font-weight: 400;
    font-family: PingFang SC;
    position: absolute;
    top: 0.16rem;
    left: 1.24rem;
    color: #333333;
  }
  & > :nth-child(3) {
    font-size: 0.16rem;
    font-weight: 400;
    font-family: PingFang SC;
    color: #333333;
    width: 2.8rem;
    height: 3.24rem;
    border-radius: 0.02rem;
    position: absolute;
    left: 0.2rem;
    top: 0.58rem;
    border: 1px solid #cccccc;
    overflow-y: auto;
    & > :nth-child(1) {
      width: 2.4rem;
      height: 3.22rem;
      margin-left: 0.2rem;
      // background-color: red;
      .size1 {
        text-align: left;

        word-wrap: break-word;
        p {
          margin-top: 0.15rem;
          span {
            // color: red !important;
            background-color: transparent !important;
            font-size: 0.15rem !important;
          }
        }
        p:last-child {
          padding-bottom: 0.15rem;
        }
      }
    }
  }
  & > :nth-child(4) {
    button {
      width: 2.82rem;
      height: 0.4rem;
      background-color: #f44242;
      border-radius: 0.02rem;
      position: absolute;
      top: 4.01rem;
      left: 0.2rem;
      border: none;
      border: 1px solid #f44242;
      color: #ffffff;
      font-weight: 400;
      font-family: PingFang SC;
      font-size: 0.16rem;
    }
  }
}

// 正文内容
.contents3 {
  width: 12rem;
  margin: 0 auto;
  // height: 100%;
  overflow-x: hidden;
  position: relative;
  .paytitle {
    & > :nth-child(1) {
      font-size: 0.24rem;
      font-family: Arial;
      font-weight: 400;
      text-align: left;
      margin-left: 1.2rem;
      margin-top: 0.95rem; //0.2rem
    }
  }
  // 服务器和角色
  .paycontent {
    width: 100%;
    height: 1.54rem;
    background: rgba(255, 255, 255, 0.96);
    margin-top: 0.48rem;
    border: 1px solid rgba(44, 62, 88, 0.07);
    border-radius: 0.1rem;
    box-shadow: 0 0.08rem 0.28rem rgba(31, 48, 75, 0.07);
    box-sizing: border-box;
    & > :nth-child(1) {
      width: 100%;
      margin-left: 0.2rem;
      padding-top: 0.3rem;
      font-size: 0.18rem;
      font-weight: 400;
      font-family: Arial;
      text-align: left;
      height: 0.2rem;
      line-height: 0.2rem;
      i {
        width: 0.04rem;
        height: 0.2rem;
        display: inline-block;
        // margin-left: 0.16rem;
        margin-right: 0.08rem;
        vertical-align: top;
        img {
          height: 0.2rem;
          width: 0.04rem;
          border-radius: 0.05rem;
        }
      }
    }
    .paycontentCh1 {
      display: flex;
      margin-top: 0.25rem;
      & > :nth-child(1) {
        display: flex;
        width: 3.6rem;
        height: 0.48rem;
        margin-left: 0.2rem;
        align-items: center;

        .role-select {
          width: 100%;
          --el-color-primary: #d9001b;

          .el-input__wrapper {
            height: 0.48rem;
            padding: 0 0.14rem;
            border-radius: 0.06rem;
            box-shadow: 0 0 0 1px #dfe3e8 inset;
            box-sizing: border-box;
            transition: box-shadow 0.2s ease;
          }

          .el-input__wrapper.is-focus {
            box-shadow: 0 0 0 1px #d9001b inset;
          }

          .el-input__inner {
            color: #333333;
            font-size: 0.16rem;
          }
        }
      }
      & > :nth-child(2) {
        width: 3.6rem;
        height: 0.48rem;
        margin-left: 0.15rem;
        border: 1px solid #e6e6e6;
        display: flex;
        align-items: center;

        border-radius: 0.04rem;
        select {
          width: 3.22rem;
          display: block;
          border: none;
          outline: none;
          font-size: 0.163rem;
          margin-left: 0.1rem;
          line-height: 0.26rem;
          background-color: rgba(255, 255, 255, 0.2);
          color: #333333;
        }
      }
    }
    .paycontentCh3 {
      display: flex;
      margin-top: 0.15rem;
      .serveenter {
        width: 3.6rem;
        height: 0.48rem;
        border: 1px solid #e6e6e6;
        display: flex;
        align-items: center;
        margin-left: 0.2rem;

        line-height: normal;
        border-radius: 0.04rem;

        select {
          margin-left: 0.1rem;
          width: 3.21rem;
          display: block;
          line-height: 0.26rem;
          color: #333333;
          border: none;
          outline: none;
          font-size: 0.163rem;
          background-color: rgba(255, 255, 255, 0.2);
        }
      }
      .serveenter2 {
        width: 4.6rem;
        height: 0.48rem;
        margin-left: 0.15rem;
        & > :nth-child(1) {
          display: flex;
          & > :nth-child(1) {
            width: 3.6rem;
            height: 0.48rem;
            border: 1px solid #e6e6e6;

            align-items: center;
            line-height: normal;
            border-radius: 0.04rem;
            // margin-top: 0.08rem;
            user-select: none;
            input {
              width: 3rem;
              height: 0.48rem;
              margin-left: 0.5%;
              padding-left: 0.16rem;
              display: block;
              line-height: 0.25rem;
              font-size: 0.16rem;
              border: none;
              outline: none;
              color: #333333;
            }
            input::-webkit-input-placeholder {
              color: grey;
            }
          }

          button {
            margin-left: 0.2rem;
            font-size: 0.16rem;
            height: 0.48rem;
            width: 0.85rem;
            border: 1px solid #f44242;
            border-radius: 0.04rem;
            background: #f44242;
            color: #ededed;
            cursor: pointer;
          }
        }
      }
    }
    .paycontentCh4 {
      font-size: 0.15rem;
      font-weight: 400;
      font-family: PingFang SC;
      color: #dd1415;
      text-align: left;
      padding-top: 0.05rem;
      margin-left: 0.2rem;
    }
    .paycontentCh2 {
      & > :nth-child(1) {
        color: rgb(51, 51, 51);
        font-family: Arial;
        font-size: 18px;
        font-weight: 400;
      }
      & > :nth-child(2) {
        margin: 0 auto;
        margin-top: 0.1rem;
        color: rgb(255, 255, 255);
        font-family: Arial;
        font-size: 16px;
        font-weight: 400;
        width: 0.9rem;
        height: 0.4rem;
        background: rgb(217, 0, 27);
        border-radius: 0.05rem;
        text-align: center;
        line-height: 0.4rem;
        cursor: pointer;
      }
    }
    .BGgrey2 {
      position: fixed;
      left: 50%;
      top: 50%;
      z-index: 1001;
      width: 420px;
      max-width: calc(100vw - 32px);
      max-height: calc(100vh - 48px);
      padding: 40px 40px 32px;
      overflow-y: auto;
      box-sizing: border-box;
      transform: translate(-50%, -50%);
      background: #fff;
      border-radius: 16px;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
      color: #333;
      font-family: Arial, "PingFang SC", sans-serif;
      text-align: left;
    }

    .login-close {
      position: absolute;
      top: 14px;
      right: 14px;
      display: flex;
      width: 32px;
      height: 32px;
      padding: 6px;
      align-items: center;
      justify-content: center;
      color: #999;
      background: transparent;
      border: 0;
      border-radius: 50%;
      cursor: pointer;
      transition: color 0.2s, background-color 0.2s;

      svg {
        width: 20px;
        height: 20px;
        fill: none;
        stroke: currentColor;
        stroke-width: 1.8;
        stroke-linecap: round;
      }

      &:hover,
      &:focus-visible {
        color: #555;
        background: #f4f4f4;
        outline: none;
      }
    }

    .login-brand-logo {
      display: block;
      width: auto;
      max-width: 100%;
      height: 48px;
      margin: 0 auto 28px;
      object-fit: contain;
    }

    .login-form {
      width: 100%;
    }

    .login-input-wrap {
      position: relative;
      display: flex;
      width: 100%;
      align-items: center;
    }

    .login-password-wrap {
      margin-top: 12px;
    }

    .login-input-icon {
      position: absolute;
      left: 14px;
      z-index: 1;
      width: 18px;
      height: 18px;
      pointer-events: none;
      fill: none;
      stroke: #bbb;
      stroke-width: 1.8;
      stroke-linecap: round;
      stroke-linejoin: round;
    }

    .login-input-field {
      width: 100%;
      height: 48px;
      padding: 0 42px;
      box-sizing: border-box;
      color: #333;
      font-family: inherit;
      font-size: 14px;
      line-height: 48px;
      background: #fafafa;
      border: 1px solid #ddd;
      border-radius: 10px;
      outline: none;
      transition: border-color 0.2s, background-color 0.2s,
        box-shadow 0.2s;

      &:focus {
        background: #fff;
        border-color: #c31212;
        box-shadow: 0 0 0 2px rgba(195, 18, 18, 0.08);
      }

      &::placeholder {
        color: #bbb;
        font-size: 13px;
      }
    }

    .login-password-toggle {
      position: absolute;
      right: 10px;
      display: flex;
      width: 30px;
      height: 30px;
      padding: 5px;
      align-items: center;
      justify-content: center;
      color: #bbb;
      background: transparent;
      border: 0;
      border-radius: 6px;
      cursor: pointer;

      svg {
        width: 18px;
        height: 18px;
        fill: none;
        stroke: currentColor;
        stroke-width: 1.7;
        stroke-linecap: round;
        stroke-linejoin: round;
      }

      &:hover,
      &:focus-visible {
        color: #888;
        background: #f1f1f1;
        outline: none;
      }
    }

    .login-submit {
      width: 100%;
      height: 48px;
      margin-top: 20px;
      color: #fff;
      font-family: inherit;
      font-size: 16px;
      font-weight: 600;
      background: linear-gradient(135deg, #c31212, #d63031);
      border: 0;
      border-radius: 10px;
      cursor: pointer;
      transition: transform 0.2s, box-shadow 0.2s;

      &:hover,
      &:focus-visible {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(195, 18, 18, 0.4);
        outline: none;
      }

      &:active {
        transform: translateY(0);
      }
    }

    .login-divider {
      display: flex;
      margin: 24px 0 20px;
      align-items: center;

      &::before,
      &::after {
        height: 1px;
        flex: 1;
        background: #e8e8e8;
        content: "";
      }

      span {
        padding: 0 16px;
        color: #bbb;
        font-size: 12px;
        white-space: nowrap;
      }
    }

    .login-social-methods {
      display: flex;
      justify-content: center;
    }

    .login-social-item {
      display: flex;
      padding: 0;
      flex-direction: column;
      align-items: center;
      gap: 6px;
      color: #999;
      font-family: inherit;
      background: transparent;
      border: 0;
      cursor: pointer;

      &:hover .login-social-icon,
      &:focus-visible .login-social-icon {
        border-color: #4285f4;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        transform: translateY(-1px);
      }

      &:focus-visible {
        outline: none;
      }
    }

    .login-social-icon {
      display: flex;
      width: 44px;
      height: 44px;
      box-sizing: border-box;
      align-items: center;
      justify-content: center;
      background: #fff;
      border: 1px solid #e0e0e0;
      border-radius: 50%;
      transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;

      svg {
        width: 20px;
        height: 20px;
      }
    }

    .login-social-label {
      color: #999;
      font-size: 11px;
      line-height: 1.4;
    }

    @media (max-width: 580px), (max-height: 620px) {
      .BGgrey2 {
        max-height: calc(100vh - 32px);
        padding: 32px 24px 26px;
      }

      .login-brand-logo {
        height: 42px;
        margin-bottom: 24px;
      }
    }
  }
  // 商品列表
  .paycontent3 {
    width: 100%;
    background: rgba(255, 255, 255, 0.96);
    border: 1px solid rgba(44, 62, 88, 0.07);
    border-radius: 0.1rem;
    box-shadow: 0 0.08rem 0.28rem rgba(31, 48, 75, 0.07);
    box-sizing: border-box;
    margin-top: 0.3rem;
    .titile2 {
      width: 100%;
      & > :nth-child(1) {
        width: 100%;
        padding-top: 0.3rem;
        margin-left: 0.2rem;
        font-size: 0.18rem;
        font-weight: 400;
        font-family: Arial;
        text-align: left;
        display: flex;
        height: 0.2rem;
        line-height: 0.2rem;
        i {
          width: 0.04rem;
          height: 0.15rem;
          display: inline-block;
          // margin-left: 0.16rem;
          margin-right: 0.08rem;
          vertical-align: top;
          img {
            height: 0.2rem;
            width: 0.04rem;
            border-radius: 0.08rem;
          }
        }
      }
    }

    // 新增
    .commodity_tab {
      margin-top: 0.25rem;
      margin-left: 0.16rem;
      font-size: 0.14px;
      text-align: left;
      padding: 5px 0px;
    }
    .commodity_tab span {
      display: inline-block;
      height: 0.4rem;
      text-align: center;
      vertical-align: middle;
      line-height: 0.4rem;
      font-size: 0.18rem;
      font-weight: 400;
      margin-right: 0.47rem;
      border-radius: 0.1rem;
      padding: 0 0.11rem;

      margin-bottom: 0.1rem;
    }
    .selected {
      color: white;
      background-color: rgb(242, 0, 29);
    }
    .noselected {
      color: rgb(51, 51, 51);
      background-color: rgb(240, 240, 240);
    }

    .PayMone {
      width: 100%;
      .PayMoneli {
        list-style: none;
        .PayMone2 {
          width: 100%;
          display: flex;
          flex-wrap: wrap;

          padding-bottom: 0.3rem;
          margin-top: 0.06rem;
          .PayMoneli2 {
            list-style: none;
            width: 2.2rem;
            height: 3.14rem;
            border: 1px solid #e6e6e6;
            margin-top: 0.1rem;
            border-radius: 0.04rem;
            margin-left: 0.16rem;
            position: relative;

            img {
              width: 1.2rem;
              height: 1.2rem;
              margin: 0 auto;
              margin-top: 0.25rem;
            }

            .good_title {
              font-size: 0.16rem;
              font-weight: 400;
              font-family: Arial;
              color: rgb(51, 51, 51);
              margin-top: 0.1rem;
              margin-left: 0.15rem;
              text-align: left;
              white-space: nowrap; /* 保证文本在一行内显示 */
              overflow: hidden; /* 超出容器部分隐藏 */
              text-overflow: ellipsis; /* 超出部分显示为省略号 */
            }
            .good_Amount {
              font-size: 0.18rem;
              font-weight: 400;
              font-family: Arial;
              color: rgb(242, 0, 29);
              margin-top: 0.05rem;
              margin-left: 0.15rem;
              text-align: left;
              span {
                font-size: 0.14rem;
                color: rgb(170, 170, 170);
                text-decoration-line: line-through;
              }
            }
            .good_limitNum {
              // width:0.6rem;
              font-size: 0.12rem;
              font-weight: 400;
              font-family: Arial;
              line-height: 0.17rem;
              color: rgb(0, 0, 0);
              margin-top: 0.05rem;
              margin-left: 0.15rem;
              text-align: left;
              span {
                background: rgb(255, 217, 80);
                padding: 0.04rem;
              }
            }

            .good_button {
              width: 100%;
              height: 0.36rem;
              position: absolute;
              bottom: 0.25rem;

              display: flex;
              justify-content: center; /* 水平居中 */
              align-items: center; /* 垂直居中 */
              button {
                width: 1.72rem;
                height: 0.36rem;
                color: rgb(242, 242, 242);
                background: rgb(217, 0, 27);
                display: block;
                border: none;

                font-weight: 400;
                font-size: 0.18rem;
                border-radius: 0.08rem;
                // position: absolute;
                // bottom: 0.25rem;
                cursor: pointer;
              }
            }
          }
          // .activeCss {
          //   width: 2.2rem;
          //   height: 2.86rem;
          //   border: 1px solid rgb(217, 0, 27);
          //   button {
          //     background: rgb(217, 0, 27);
          //     color: #ffffff;
          //   }
          // }
        }
      }
    }
  }
  // 充值说明
  .paycontent4 {
    width: 100%;

    background: rgba(255, 255, 255, 0.96);
    border: 1px solid rgba(44, 62, 88, 0.07);
    border-radius: 0.1rem;
    box-shadow: 0 0.08rem 0.28rem rgba(31, 48, 75, 0.07);
    box-sizing: border-box;
    margin-top: 0.3rem;
    margin-bottom: 0.4rem;
    .titile2 {
      width: 100%;
      & > :nth-child(1) {
        width: 100%;
        padding-top: 0.3rem;
        margin-left: 0.2rem;
        font-size: 0.18rem;
        font-weight: 400;
        font-family: Arial;
        text-align: left;
        display: flex;
        height: 0.2rem;
        line-height: 0.2rem;
        i {
          width: 0.04rem;
          height: 0.15rem;
          display: inline-block;
          // margin-left: 0.16rem;
          margin-right: 0.08rem;
          vertical-align: top;
          img {
            height: 0.2rem;
            width: 0.04rem;
            border-radius: 0.08rem;
          }
        }
      }
    }
    .size1 {
      font-size: 0.15rem;
      text-align: left;
      margin-left: 0.2rem;
      margin-top: 0.28rem;
      word-wrap: break-word;
      line-height: 0.3rem;
      padding-bottom: 0.2rem;
    }
  }
}

// foot信息展示
.footNav {
  width: 100%;
  height: 1.86rem;
  background-color: rgb(66, 66, 66);
  & > :nth-child(1) {
    display: flex;
    width: 12rem;
    margin: 0 auto;
    justify-content: space-between;
    .foot_left {
      img {
        width: 2.86rem;
        height: 0.72rem;
        // margin-left: 2rem;
        margin-top: 0.57rem;
      }
    }
    .foot_right {
      margin-top: 0.63rem;
      margin-right: 0.2rem;
      .foot_right_top {
        height: 0.2rem;
        line-height: 0.2rem;
        font-size: 0.14rem;
        color: rgb(255, 255, 255);
        margin-bottom: 0.1rem;
        text-align: right;
        a {
          color: rgb(255, 255, 255);
        }
        a:hover {
          color: rgb(255, 255, 255);
        }
        a:visited {
          color: rgb(255, 255, 255);
        }
      }
      .foot_right_bottom {
        text-align: right;
        height: 0.2rem;
        line-height: 0.2rem;
        font-size: 0.14rem;
        color: rgb(255, 255, 255);
      }
    }
  }
}

/* 假设你要修改的Select组件的类名为 .custom-select */
.el-select-dropdown__item {
  height: 0.6rem; /* 你想要设置的高度 */
  line-height: 0.6rem; /* 确保文本垂直居中 */
}
</style>
